// Auto-generated from gen_effect_id.ts
// DO NOT EDIT THIS FILE DIRECTLY

const data = {
  '2': 'E88',
  '4': 'E8A',
  'ABitBerserk': '905',
  'AMansBestFriend': '16E',
  'Abandon': '2DA',
  'AbandonIi': '2DB',
  'AbandonIii': '2DC',
  'AbandonIv': '2DD',
  'Abandonment_286': '286',
  'Abandonment_58A': '58A',
  'AbdomenTear': 'BE9',
  'AboutFace_1449': '1449',
  'AboutFace_50E': '50E',
  'AboutFace_7A7': '7A7',
  'AboutFace_872': '872',
  'AboutFace_94E': '94E',
  'AboutFace_DD3': 'DD3',
  'AboutFace_E73': 'E73',
  'AboutFace_E84': 'E84',
  'Abridged': '537',
  'AbsoluteBind': '1B2',
  'AbsoluteProtect': '944',
  'AbyssalEdge': '1056',
  'Acceleration': '4D6',
  'AccelerationBomb_1030': '1030',
  'AccelerationBomb_430': '430',
  'AccelerationBomb_568': '568',
  'AccelerationBomb_A61': 'A61',
  'AccelerationBomb_ED1': 'ED1',
  'AccelerationBomb_EDA': 'EDA',
  'Acclaim': 'C5B',
  'Accretion': '644',
  'AccuracyDown': '1C',
  'AccuracyUp': '1B',
  'AccursedFlame': '5F7',
  'AccursedPoison': '795',
  'AccursedPox': '43F',
  'AcidicBite': '819',
  'ActingDps': 'B6D',
  'ActingHealer': 'B6E',
  'ActingTank': 'B6F',
  'AdamantPurged': 'A44',
  'AdamantScales': '104D',
  'AdamantinonThelema': 'B3F',
  'Adaptation_62D': '62D',
  'Adaptation_639': '639',
  'Addersting': 'C2B',
  'Addle_4B3': '4B3',
  'Addle_7C4': '7C4',
  'AdventOfChocobastion': '1014',
  'AegisBoon': '28F',
  'Aero': '8F',
  'AeroIi': '90',
  'AeroIii': '31E',
  'AetherMortar': 'C54',
  'AetherRot': '5C3',
  'AetherRotImmunity': '5C4',
  'AetherSickness_30D': '30D',
  'AetherSickness_AAB': 'AAB',
  'Aetherflow': '130',
  'AetherhuesIi_1005': '1005',
  'AetherhuesIi_E5C': 'E5C',
  'Aetherhues_1004': '1004',
  'Aetherhues_E5B': 'E5B',
  'AetherialAegis': '8F7',
  'AetherialDepletion': '9A9',
  'AetherialEnhancement': '483',
  'AetherialExchange': 'CF1',
  'AetherialField': '155',
  'AetherialGain': '10A0',
  'AetherialSurge_44A': '44A',
  'AetherialSurge_476': '476',
  'AetherialWard': '9C7',
  'AetheriallyCharged': '5F8',
  'AetheriallyPrimed': '6DA',
  'AethericBurst': '88B',
  'AethericMimicryDps': '84D',
  'AethericMimicryHealer': '84E',
  'AethericMimicryTank': '84C',
  'AetherochemicalBomb_1FD': '1FD',
  'AetherochemicalBomb_2D3': '2D3',
  'AetherochemicalNanospores_244': '244',
  'AetherochemicalNanospores_245': '245',
  'Aetheronecrosis': 'CF9',
  'Aetherstock': '1028',
  'Aethersucker': 'AEF',
  'AethertrailAttunement_327': '327',
  'AethertrailAttunement_38C': '38C',
  'Affixed': '4F3',
  'AfflatusSolace': '7F4',
  'AggravatedAssault': '461',
  'AggressivePosture': '6EC',
  'AggressiveStance': '1CC',
  'Agitation': 'D6',
  'AirAnchorPrimed': 'C50',
  'AirForceSimulation': '5D2',
  'Airbound': '5FD',
  'Ajisai': '6F3',
  'AlexandrianBarrier': '12E8',
  'AlexandrianSwiftdodge': '12EA',
  'AlexandrianSwiftstep': '12EB',
  'AllaganField': '1C6',
  'AllaganImmunity': '14E',
  'AllaganRot': '14D',
  'AllaganVenom': '1C5',
  'AlliedArithmeticks': '3FC',
  'Almagest': '563',
  'AlphaTarget': 'DE8',
  'AlteredStates': '56B',
  'AmbitiousLure': 'F84',
  'AmmunitionLoaded': '35E',
  'Amnesia_1072': '1072',
  'Amnesia_444': '444',
  'Amnesia_5': '5',
  'Analysis': 'C56',
  'Anatman': '746',
  'AncientCircle_83E': '83E',
  'AncientCircle_DCE': 'DCE',
  'AncientDouble': '899',
  'AncientFrost': 'DB2',
  'Anemomorph_300': '300',
  'Anemomorph_8C4': '8C4',
  'AngelsSnack': '9BF',
  'AngelsWhisper': '752',
  'AnglersArt': 'ADA',
  'AnglersFortune': '352',
  'Anguish': 'AA6',
  'AnnihilationMode': '61C',
  'Anointed': '11EB',
  'AnotherVictim': '2EE',
  'Anthropomorph': '2FE',
  'AntiCoagulant': '3EC',
  'Antibody': '19A',
  'Anticipation': '4AA',
  'Apathetic_5C0': '5C0',
  'Apathetic_69F': '69F',
  'ApexBlades': 'EDC',
  'ApexWings': 'EDB',
  'Apocatastasis_AA': 'AA',
  'Apocatastasis_C94': 'C94',
  'Apokalypsis': 'E3C',
  'AquaticConception': 'D0A',
  'Aquaveil_A94': 'A94',
  'Aquaveil_C0E': 'C0E',
  'ArborCall': 'E9',
  'ArborCallIi': 'F2',
  'ArcanaBreaker': '3C8',
  'ArcaneAttraction': 'D39',
  'ArcaneBulwark': '64B',
  'ArcaneCircle': 'A27',
  'ArcaneDesign': '1054',
  'ArcaneFever': 'D3B',
  'ArcaneStop': '1098',
  'ArcaneTriumph_D37': 'D37',
  'ArcaneTriumph_D38': 'D38',
  'ArcanumBlessing': '38B',
  'AreaOfInfluenceUp_26A': '26A',
  'AreaOfInfluenceUp_6D5': '6D5',
  'AreaOfInfluenceUp_775': '775',
  'AreaOfInfluenceUp_EB8': 'EB8',
  'ArmOfPurgatory': '24E',
  'ArmedToTheTeeth': '116A',
  'ArmoredScales': '1001',
  'ArmsLength_4B9': '4B9',
  'ArmsLength_7C0': '7C0',
  'ArmsLength_87C': '87C',
  'ArmsLength_885': '885',
  'ArmsUp': '498',
  'ArmysEthos': '78D',
  'ArmysMuse': '78C',
  'ArmysPaeon_89': '89',
  'ArmysPaeon_8A': '8A',
  'ArmysPaeon_8A6': '8A6',
  'ArmysPaeon_8AA': '8AA',
  'ArrowDrawn_393': '393',
  'ArrowDrawn_D4C': 'D4C',
  'ArrowDrawn_FCB': 'FCB',
  'ArrowHeld': '39A',
  'ArtificialBoost': '700',
  'ArtificiallyEnhanced_6E4': '6E4',
  'ArtificiallyEnhanced_6E5': '6E5',
  'Ascended': 'E02',
  'Ashen': '56C',
  'AspectedBenefic': '343',
  'AspectedHelios': '344',
  'AspectedToFire': '4FE',
  'AspectedToIce': '4FF',
  'AspectedToLightning': '500',
  'Aspirstrikes': '45',
  'AssassinateReady': '7A3',
  'Assassinated': '522',
  'Assimilated': '42D',
  'Assimilation': '42C',
  'AstralAttenuation': '849',
  'AstralCloak': '6B0',
  'AstralEffect': '8BE',
  'AstralEssence': '6AE',
  'AstralFireIi_AE': 'AE',
  'AstralFireIi_C8D': 'C8D',
  'AstralFireIii_AF': 'AF',
  'AstralFireIii_D35': 'D35',
  'AstralFire_AD': 'AD',
  'AstralFire_C8C': 'C8C',
  'AstralRealignment': '18E',
  'AstralTilt': 'DF9',
  'AstralWarmth': 'C90',
  'AstralbrightSoul': 'DFC',
  'AstralstrongSoul': 'DFE',
  'Asylum_2E3': '2E3',
  'Asylum_777': '777',
  'Asylum_778': '778',
  'AtDeathsDoor': 'AB2',
  'AtTheLimit': '95C',
  'AtkDefUp': '3D2',
  'AtkDown': '3C3',
  'AtkUp': '3C2',
  'Atlas': '89E',
  'Atmosfaction': 'E07',
  'AtonementReady_76E': '76E',
  'AtonementReady_7DF': '7DF',
  'Atrophy': '287',
  'AttackDown': '1A',
  'AttackMagicPotencyDown': '22',
  'AttackMagicPotencyUp_21': '21',
  'AttackMagicPotencyUp_28A': '28A',
  'AttackUp_19': '19',
  'AttackUp_289': '289',
  'AttractionReversed': 'D3A',
  'AttractorBeamCharged': '1384',
  'Attunement': '7C6',
  'Aurora_72B': '72B',
  'Aurora_811': '811',
  'AuroralFlipper': 'A0A',
  'Auspicious': '621',
  'AuspiciousTrance': '9C1',
  'AuthoritysBoot': '105B',
  'AuthoritysExpansion': '105A',
  'AuthoritysGaze': 'EE7',
  'AuthoritysHeel': '105C',
  'AuthoritysHold': '1022',
  'AutoEther': '927',
  'AutoHealPenalty': '449',
  'AutoPotion': '926',
  'AutoRemedy': '928',
  'Autophysis': 'A3D',
  'AvariciousRuin': '9CF',
  'Awareness_49': '49',
  'Awareness_CD5': 'CD5',
  'AwayWithTheFae': '11EA',
  'BackFromTheBrink': '9D5',
  'BackUnseen_6AD': '6AD',
  'BackUnseen_E8F': 'E8F',
  'BackWithThee': '8C1',
  'BackwardBearing': 'B14',
  'BackwardFracture': 'FC7',
  'BackwardWhimsy': 'B1A',
  'BalanceDrawn_391': '391',
  'BalanceDrawn_C1D': 'C1D',
  'BalanceDrawn_FC9': 'FC9',
  'BalanceHeld': '398',
  'BalancedParty': '1083',
  'BalancedTactics': '5A2',
  'BalefulAir': '9BA',
  'BanefulImpaction': 'F2B',
  'BanishL': '677',
  'BannerOfFirmResolve': '919',
  'BannerOfHonedAcuity': '91B',
  'BannerOfHonoredSacrifice': '917',
  'BannerOfLimitlessGrace': '931',
  'BannerOfNobleEnds': '916',
  'BannerOfSolemnClarity': '91A',
  'BannerOfTirelessConviction': '918',
  'BannerOfTranscendentFinesse': '932',
  'BannerOfUnyieldingDefense': '930',
  'BardamsPrice': '4FA',
  'Barofield_241': '241',
  'Barofield_D5C': 'D5C',
  'Barrage_57F': '57F',
  'Barrage_80': '80',
  'BasicInstinct': '9C2',
  'BattleBell': '109B',
  'BattleEfficiencyDown': '2BD',
  'BattleFever': '28E',
  'BattleHighI': '853',
  'BattleHighIi': '854',
  'BattleHighIii': '855',
  'BattleHighIv': '856',
  'BattleHighV': '857',
  'BattleHigh_1085': '1085',
  'BattleHigh_28D': '28D',
  'BattleLitany_312': '312',
  'BattleLitany_586': '586',
  'BattleVoice': '8D',
  'BattlesClangor': '109C',
  'BeastkingsBoon': '482',
  'Beckoned': '793',
  'BeckoningDark_EB3': 'EB3',
  'BeckoningDark_ED2': 'ED2',
  'BeeBeGone': '1033',
  'BeeBeHere': '1034',
  'BeelovedVenom_F5C': 'F5C',
  'BeelovedVenom_F5D': 'F5D',
  'Begrimed': 'E34',
  'Behelmed_7B0': '7B0',
  'Behelmed_7B1': '7B1',
  'Bemoggled': '1D9',
  'Benoggined': 'F6C',
  'Berserk_56': '56',
  'Berserk_CB9': 'CB9',
  'BetaTarget': 'DE9',
  'Bewildered': '195',
  'BeyondBeleafed': '11E7',
  'BeyondDeath': '566',
  'BeyondLimits': '5FA',
  'BibliotaphSimulation': '5D4',
  'BigBang': 'EB0',
  'BigBounce': 'EB1',
  'BigGameFishing': 'F43',
  'BigbulgeBiggerbrain': '3EB',
  'BigbulgeGoblixer': '3E6',
  'BindResistance': '547',
  'Bind_10F4': '10F4',
  'Bind_118': '118',
  'Bind_119E': '119E',
  'Bind_1C9': '1C9',
  'Bind_234': '234',
  'Bind_3DA': '3DA',
  'Bind_541': '541',
  'Bind_9D6': '9D6',
  'Bind_C3E': 'C3E',
  'Bind_D': 'D',
  'Bind_D81': 'D81',
  'Bind_E29': 'E29',
  'Bind_EC0': 'EC0',
  'Bind_EC6': 'EC6',
  'Bind_ECD': 'ECD',
  'BindingDark': 'EB6',
  'BindingSoulSnare': 'DDB',
  'Bio': 'B3',
  'BioIi': 'BD',
  'BioIii_4BE': '4BE',
  'BioIii_52E': '52E',
  'BioblasterPrimed': 'C4F',
  'Bioblaster_74A': '74A',
  'Bioblaster_7E3': '7E3',
  'Biohacked': '6A7',
  'Biolysis_767': '767',
  'Biolysis_7F7': '7F7',
  'Biolysis_C11': 'C11',
  'Biolytic': 'C12',
  'BishopActive': 'C53',
  'BitterHate': '42A',
  'BlackHoleBuffer': '6D1',
  'BlackMenace': '3A0',
  'BlackPaint': '5BD',
  'BlackShift': 'CAE',
  'BlackWound': '565',
  'Blackblood': 'BD9',
  'BlackestNight_49A': '49A',
  'BlackestNight_51C': '51C',
  'BlackfeatherBoost': 'BB3',
  'BladeOfFaithReady': 'CB2',
  'BladeOfHonorReady': 'EF7',
  'BladeOfValor': 'AA1',
  'Bladecatcher': 'C57',
  'BlankfaceGoblixer': '3E8',
  'BlastArrowReady_A84': 'A84',
  'BlastArrowReady_C46': 'C46',
  'BlazeSpikes_11E3': '11E3',
  'BlazeSpikes_C5': 'C5',
  'BlazingAramitama': '6EE',
  'BlazingBane': '12B7',
  'BlazingSpellblade': '12B6',
  'Bleeding_1029': '1029',
  'Bleeding_102A': '102A',
  'Bleeding_111': '111',
  'Bleeding_140': '140',
  'Bleeding_153': '153',
  'Bleeding_157': '157',
  'Bleeding_282': '282',
  'Bleeding_283': '283',
  'Bleeding_3AC': '3AC',
  'Bleeding_432': '432',
  'Bleeding_6B2': '6B2',
  'Bleeding_828': '828',
  'Bleeding_95F': '95F',
  'Bleeding_980': '980',
  'Bleeding_A4C': 'A4C',
  'Bleeding_B6A': 'B6A',
  'Bleeding_B87': 'B87',
  'Bleeding_C05': 'C05',
  'Bleeding_C06': 'C06',
  'Bleeding_F7E': 'F7E',
  'Bleeding_FE4': 'FE4',
  'BlessedRain': '109D',
  'Blessing': '10AE',
  'BlessingOfBlight': 'CD0',
  'BlessingOfEarth': '2AB',
  'BlessingOfFire': '2AC',
  'BlessingOfLight_BC6': 'BC6',
  'BlessingOfLight_C33': 'C33',
  'BlessingOfLight_F1': 'F1',
  'BlessingOfTheVoid': '309',
  'Blight_175': '175',
  'Blight_293': '293',
  'Blight_890': '890',
  'BlindToGrief': '8A1',
  'BlindToRage': '8A0',
  'Blind_23B': '23B',
  'Blind_440': '440',
  'Blind_5F4': '5F4',
  'Blind_DA6': 'DA6',
  'Blind_F': 'F',
  'BlizzardCharged': '5CC',
  'Bloated_2BE': '2BE',
  'Bloated_708': '708',
  'BloodForBlood_75': '75',
  'BloodForBlood_7BD': '7BD',
  'BloodMoon': '601',
  'BloodOfTheBraax': '104A',
  'BloodOfTheDragon_2E0': '2E0',
  'BloodOfTheDragon_CC1': 'CC1',
  'BloodOfTheGorgon': 'CFE',
  'BloodPrice': '2E9',
  'BloodRush': 'A07',
  'BloodSacrifice': '6D9',
  'BloodWeapon': '2E6',
  'BloodbathL': '68D',
  'Bloodbath_54': '54',
  'Bloodbath_7BE': '7BE',
  'Bloodfest': '13BB',
  'BloodsownCircle_A29': 'A29',
  'BloodsownCircle_B9C': 'B9C',
  'Bloodwhetting_A76': 'A76',
  'Bloodwhetting_BD6': 'BD6',
  'BloodyRuin': '9CD',
  'BloomingBlue': 'D83',
  'BloomingGold': 'D84',
  'BloomingWelt': 'D9B',
  'BlownAway': '6D2',
  'BluePaint': '5BC',
  'Bluefire': '24F',
  'BluntResistanceDown_23D': '23D',
  'BluntResistanceDown_335': '335',
  'BluntResistanceDown_3A3': '3A3',
  'BluntResistanceDown_6F0': '6F0',
  'BluntResistanceDown_8C8': '8C8',
  'BluntResistanceDown_C3C': 'C3C',
  'BluntResistanceUp': '2D2',
  'BodilyManipulation': 'CF6',
  'Boiling_102C': '102C',
  'Boiling_B52': 'B52',
  'BoleDrawn_392': '392',
  'BoleDrawn_D4B': 'D4B',
  'BoleDrawn_FCA': 'FCA',
  'BoleHeld': '399',
  'Bombarium': 'FB4',
  'BondsOfDarkness': 'EB7',
  'BondsOfFlesh_1290': '1290',
  'BondsOfFlesh_1292': '1292',
  'BondsOfLoathing': '1059',
  'Boost_678': '678',
  'Boost_6B4': '6B4',
  'Boost_CB': 'CB',
  'Boosted': '990',
  'BootCampMode': '902',
  'BorneHeart': '612',
  'BorrowedFlesh': 'AC8',
  'BorrowedTime': '11D1',
  'BoundAndDetermined': 'AD9',
  'BountifulCatch': '492',
  'BowShock': '72E',
  'BraaxPulse': 'EC8',
  'Braced': '8D8',
  'BracingSuds_CE1': 'CE1',
  'BracingSuds_CE9': 'CE9',
  'BrainRot': 'CD2',
  'BrandOfTheFallen': '429',
  'BrandOfTheIreful': '27D',
  'BrandOfTheSullen': '27C',
  'BraveNewWorld': '161',
  'Bravery': '117F',
  'BraveryL': '66E',
  'BraveryOfTheSeventhDawn': 'D55',
  'Break': 'A0D',
  'BreakIiiEdict': '694',
  'BreakerOfWind': '1211',
  'BreathOfMagic': 'E80',
  'BreathOfTheGorgon': 'CFF',
  'Breathless_595': '595',
  'Breathless_A70': 'A70',
  'Briar': '1B4',
  'BrightPulse': 'E9C',
  'BrightwingedFortitude': 'A64',
  'BrightwingedFury': 'A68',
  'BrilliantConviction_40F': '40F',
  'BrilliantConviction_410': '410',
  'BrilliantConviction_411': '411',
  'BrilliantConviction_4F0': '4F0',
  'BrilliantConviction_4F1': '4F1',
  'BrilliantDynamis': 'D76',
  'BrinkOfDeath': '2C',
  'BrinyMirror': '1B0',
  'BrinyVeil_1B1': '1B1',
  'BrinyVeil_1D3': '1D3',
  'BroodRage': '174',
  'Brotherhood_4A1': '4A1',
  'Brotherhood_87E': '87E',
  'BrotherlyLove_136C': '136C',
  'BrotherlyLove_627': '627',
  'BrushWithDeath': '84F',
  'BrutalShell_76A': '76A',
  'BrutalShell_7CD': '7CD',
  'BubbleGaol_13B7': '13B7',
  'BubbleGaol_EA2': 'EA2',
  'BubbleNet': 'EA0',
  'BubbleWeave': 'E9F',
  'BullsEye': 'E9E',
  'Bulwark': '4D',
  'Bunshin_7A2': '7A2',
  'Bunshin_7DA': '7DA',
  'BurgeoningFury_10BF': '10BF',
  'BurgeoningFury_EF9': 'EF9',
  'BurnBabyBurn_116C': '116C',
  'BurnBabyBurn_116D': '116D',
  'BurningBrand': '850',
  'BurningChains_301': '301',
  'BurningChains_DB1': 'DB1',
  'BurningCounter': '3B5',
  'BurningSoul': '64D',
  'BurningUp': '1160',
  'BurningWard': '104F',
  'Burns_10B': '10B',
  'Burns_1197': '1197',
  'Burns_119F': '119F',
  'Burns_11C': '11C',
  'Burns_1F7': '1F7',
  'Burns_212': '212',
  'Burns_26B': '26B',
  'Burns_629': '629',
  'Burns_6FB': '6FB',
  'Burns_822': '822',
  'Burns_892': '892',
  'Burns_897': '897',
  'Burns_961': '961',
  'Burns_B64': 'B64',
  'Burns_B81': 'B81',
  'Burns_BF9': 'BF9',
  'Burns_BFA': 'BFA',
  'Burns_C92': 'C92',
  'Burns_CC2': 'CC2',
  'Burns_CC3': 'CC3',
  'Burns_DD1': 'DD1',
  'Burns_EF2': 'EF2',
  'Burns_FA': 'FA',
  'Burrs': '12F',
  'Burst': 'C95',
  'BurstingGrotesquerie_128D': '128D',
  'BurstingGrotesquerie_1299': '1299',
  'BuryingCounter': '3B8',
  'ButchersBlock': '55B',
  'ButterflyMotif': '12E4',
  'BuyBuyBuy_10FA': '10FA',
  'BuyBuyBuy_10FB': '10FB',
  'BuyBuyBuy_10FC': '10FC',
  'BuyersRemorse_10F6': '10F6',
  'BuyersRemorse_10F7': '10F7',
  'BuyersRemorse_10F8': '10F8',
  'ByregotsWard': 'DF',
  'CacheMeIfYouCan': '5FB',
  'Cactguard': '847',
  'CakeDecorator': '11CA',
  'CalamitysBite': 'EED',
  'CalamitysBolt': 'EEF',
  'CalamitysChill': 'EEE',
  'CalamitysEmbers': 'EEB',
  'CalamitysFlames': 'EE9',
  'CalamitysFrost': 'EEC',
  'CalamitysFulgur': 'EF0',
  'CalamitysInferno': 'EEA',
  'CallOfThePortal': 'CCC',
  'Camouflage': '728',
  'CandyCane': 'E3A',
  'CardDrawn': '33A',
  'CardHeld': '33C',
  'CarnalChill': '365',
  'CarrotOfHappiness': 'AF5',
  'CarrotPower': '1135',
  'CascadingLatentDefect_687': '687',
  'CascadingLatentDefect_DC8': 'DC8',
  'CastingChlamys': 'AF0',
  'Catalyze_77E': '77E',
  'Catalyze_C10': 'C10',
  'CatchAndRelease': '2FD',
  'CatharsisOfCorundum_10C8': '10C8',
  'CatharsisOfCorundum_A7D': 'A7D',
  'Causality': '202',
  'CausticBite_4B0': '4B0',
  'CausticBite_529': '529',
  'CelestialRiver': 'C21',
  'CelestialTide': 'C22',
  'CellBlock_11BE': '11BE',
  'CellBlock_11BF': '11BF',
  'CellBlock_11C0': '11C0',
  'CellBlock_11C1': '11C1',
  'Cemented_5C1': '5C1',
  'Cemented_5EC': '5EC',
  'CetaceousSpeed': 'A09',
  'ChainDeathmatch': 'FB3',
  'ChainOfPurgatory': '24D',
  'ChainSaw': 'C52',
  'ChainSawPrimed': 'C51',
  'ChainStratagem_4C5': '4C5',
  'ChainStratagem_57E': '57E',
  'ChainsOfCondemnation': '11D2',
  'ChainsOfEverlastingLight': '103D',
  'ChainsOfMemory': '65B',
  'ChainsOfPassion_12EC': '12EC',
  'ChainsOfPassion_12ED': '12ED',
  'ChainsOfResentment': 'CDE',
  'ChanceOfBlizzards': 'FAE',
  'ChanceOfGaleForceWinds': 'FAD',
  'ChanceOfHyperelectricity': 'FAC',
  'ChanceOfWildfires': 'FAB',
  'Chanchala_534': '534',
  'Chanchala_582': '582',
  'Chaos': '204',
  'ChaosThrust_520': '520',
  'ChaosThrust_76': '76',
  'ChaoticCyclone': '81E',
  'ChaoticCycloneReady': '7C8',
  'ChaoticSpring': 'A9F',
  'Charge_190': '190',
  'Charge_2C6': '2C6',
  'ChelicResistanceDown': 'CF8',
  'Chelomorph': 'CF3',
  'ChelonianGate': '9C0',
  'Chicken_284': '284',
  'Chicken_44E': '44E',
  'ChilledToTheBone': '794',
  'ChillingSuds_CE2': 'CE2',
  'ChillingSuds_CEA': 'CEA',
  'ChimericSoul': 'DD9',
  'Chiromorph': '2FF',
  'Chiten': '4D8',
  'ChocoBeak': 'EC',
  'ChocoReflect': '281',
  'ChocoRegen': 'ED',
  'ChocoSurge': 'EE',
  'Chocobastion': '1015',
  'ChorusAligned': 'AFA',
  'Chum': '2FB',
  'Churning': '4F6',
  'CircleOfClarity': 'AEB',
  'CircleOfPower': '2E2',
  'CircleOfSacrifice': 'A28',
  'CircleOfScorn': 'F8',
  'ClarifyingDraw': 'A99',
  'ClarityOfCorundum': 'A7C',
  'Clashing': '4F7',
  'ClawMotif': '100B',
  'ClawSketch': '101E',
  'Clawbound_456': '456',
  'Clawbound_AD7': 'AD7',
  'ClawedMuse': '100F',
  'CleanerShot': '359',
  'ClericStance_91': '91',
  'ClericStance_9B4': '9B4',
  'CloakOfDeath': '253',
  'CloakOfWaningLight': '14E8',
  'CloakOfWaxingDark': '14E9',
  'Clockwork': '5A3',
  'CloseCaloric': 'E05',
  'ClosedPosition_71F': '71F',
  'ClosedPosition_7EA': '7EA',
  'CloudyCaress': '10B8',
  'CloyingCondensation': '9E4',
  'CocoonOfThePenitent': '70F',
  'CodeMi': 'D77',
  'CoeurlForm': '6D',
  'ColdBlade1': '8FB',
  'ColdBlade2': '8FC',
  'ColdBrand1': '8F4',
  'ColdBrand2': '8F8',
  'ColdFog': '9BD',
  'ColdSpell': 'AB3',
  'ColdSweats': '102E',
  'Collect': '325',
  'CollectableSynthesis': '387',
  'CollectiveUnconscious_34F': '34F',
  'CollectiveUnconscious_350': '350',
  'CollectiveUnconscious_351': '351',
  'CollectiveUnconscious_8EB': '8EB',
  'CollectorsFocus': 'A6C',
  'CollectorsHighStandard': 'F47',
  'CollectorsStandard': '972',
  'ColliderConductor': 'FA6',
  'Combust': '346',
  'CombustIi': '34B',
  'CombustIii_759': '759',
  'CombustIii_7F9': '7F9',
  'Cometeor': '580',
  'ComeuppanceReady': '10C0',
  'ComfortZone': '105',
  'CompanionAttackUp': '21A',
  'CompanionAttackUpIi': '21B',
  'CompanionEnmityUp': '220',
  'CompanionEnmityUpIi': '221',
  'CompanionExpUp': '218',
  'CompanionExpUpIi': '219',
  'CompanionHealingPotencyUp': '21C',
  'CompanionHealingPotencyUpIi': '21D',
  'CompanionMaximumHpUp': '21E',
  'CompanionMaximumHpUpIi': '21F',
  'CompressedLightning_400': '400',
  'CompressedLightning_85F': '85F',
  'CompressedWater_3FF': '3FF',
  'CompressedWater_85E': '85E',
  'ComputationBoost': '61D',
  'ComputationError': '61E',
  'ComputationMode': '61A',
  'Concealed_2A4': '2A4',
  'Concealed_655': '655',
  'Concealed_F9D': 'F9D',
  'Concentrate': '88A',
  'ConcentratedPoison_2A5': '2A5',
  'ConcentratedPoison_3F3': '3F3',
  'ConcentratedPoison_416': '416',
  'ConcentratedPoison_CBD': 'CBD',
  'ConcentratedPoison_E6C': 'E6C',
  'Concentration': '18C',
  'ConcentrationConcentrate': 'F77',
  'ConceptualMastery': 'CFD',
  'Concussion_10A': '10A',
  'Concussion_3E4': '3E4',
  'Concussion_3E5': '3E5',
  'Concussion_821': '821',
  'Concussion_837': '837',
  'Concussion_B63': 'B63',
  'Concussion_B80': 'B80',
  'Concussion_BF7': 'BF7',
  'Concussion_BF8': 'BF8',
  'Concussion_DB9': 'DB9',
  'Concussion_DC1': 'DC1',
  'CondensedWaveCannonKyrios_DB3': 'DB3',
  'CondensedWaveCannonKyrios_DB4': 'DB4',
  'CondensedWaveCannonKyrios_DB5': 'DB5',
  'CondensedWaveCannonKyrios_DB6': 'DB6',
  'Confession': '4C3',
  'Confiteor': '81C',
  'ConfiteorReady_BCB': 'BCB',
  'ConfiteorReady_BD4': 'BD4',
  'Confused_417': '417',
  'Confused_503': '503',
  'Confused_B': 'B',
  'Conked': '843',
  'Connectivity': '5C6',
  'Consolation': 'C1A',
  'Consumption': 'CF5',
  'ContactProhibitionOrdained_864': '864',
  'ContactProhibitionOrdained_BEF': 'BEF',
  'ContactRegulationOrdained_865': '865',
  'ContactRegulationOrdained_BF0': 'BF0',
  'ContractualObligation': '6C0',
  'Convalescence_48': '48',
  'Convalescence_4A8': '4A8',
  'CoolTint': '1164',
  'CorporealReturn': '18F',
  'CorpsACorps': '7DC',
  'CorruptedCrystal': '176',
  'Counter': '207',
  'Counterstance': '108E',
  'Cover_50': '50',
  'Cover_514': '514',
  'Cover_96C': '96C',
  'Covered_1100': '1100',
  'Covered_51': '51',
  'Covered_515': '515',
  'Covered_96D': '96D',
  'CraftersGrace': '2D',
  'CraftersSoul': '36F',
  'CraftingFacility': '29',
  'Craniotomy': 'B98',
  'CraterLater': '1102',
  'Craven': '58D',
  'CravenCompanionship': 'B96',
  'CreepingPoison': 'B0A',
  'CrestOfTimeBorrowed_A24': 'A24',
  'CrestOfTimeBorrowed_A25': 'A25',
  'CrestOfTimeBorrowed_B2D': 'B2D',
  'CrestOfTimeReturned_A26': 'A26',
  'CrestOfTimeReturned_B2E': 'B2E',
  'CrimsonStrikeReady_1130': '1130',
  'CrimsonStrikeReady_1133': '1133',
  'CriticalFactor': 'E0A',
  'CriticalOverflowBug_681': '681',
  'CriticalOverflowBug_DC5': 'DC5',
  'CriticalPerformanceBug': 'D65',
  'CriticalSkill': '41',
  'CriticalStrikes_12D': '12D',
  'CriticalStrikes_243': '243',
  'CriticalStrikes_656': '656',
  'CriticalStrikes_705': '705',
  'CriticalSynchronizationBug_680': '680',
  'CriticalSynchronizationBug_DC4': 'DC4',
  'CriticalUnderflowBug_682': '682',
  'CriticalUnderflowBug_DC6': 'DC6',
  'CriticalUp': '4A4',
  'CritterResistance_3CA': '3CA',
  'CritterResistance_3D6': '3D6',
  'CritterVulnerability': '3CE',
  'CrownOfTheGorgon': 'D18',
  'CrumblingBulwark': '64F',
  'Cryomania': '1076',
  'CrystalBurden': 'EE2',
  'CrystalCourier': 'E78',
  'CrystalVeil': '142',
  'Crystallized': 'EE3',
  'Cube': '42E',
  'CureIiiReady': 'C0B',
  'Curl': '136',
  'CurseOfCompanionship': '1208',
  'CurseOfDarkness': '953',
  'CurseOfEverlastingLight': '103E',
  'CurseOfImmolation': '1209',
  'CurseOfSolitude': '1207',
  'CurseOfTheBombpyre': '1279',
  'CurseOfTheMummy': '25A',
  'CurseOfTheRonka': '736',
  'CursedChange': '10F9',
  'CursedShriek': '1C4',
  'CursedVoice': '1C3',
  'Cursekeeper': '6BD',
  'CuttingCounter': '3B7',
  'DadalumaSimulation': '5D3',
  'DamageBarrier': 'D4D',
  'DamageDown_1112': '1112',
  'DamageDown_1113': '1113',
  'DamageDown_11A2': '11A2',
  'DamageDown_274': '274',
  'DamageDown_2B8': '2B8',
  'DamageDown_3E': '3E',
  'DamageDown_3F8': '3F8',
  'DamageDown_442': '442',
  'DamageDown_82C': '82C',
  'DamageDown_964': '964',
  'DamageDown_9DA': '9DA',
  'DamageDown_B5F': 'B5F',
  'DamageDown_C5E': 'C5E',
  'DamageDown_CE8': 'CE8',
  'DamageDown_D7': 'D7',
  'DamageDown_F7C': 'F7C',
  'DamageOverTime': '3D3',
  'DamageUp_107': '107',
  'DamageUp_1137': '1137',
  'DamageUp_11BA': '11BA',
  'DamageUp_122': '122',
  'DamageUp_12C': '12C',
  'DamageUp_14C': '14C',
  'DamageUp_193': '193',
  'DamageUp_1BB': '1BB',
  'DamageUp_1F9': '1F9',
  'DamageUp_236': '236',
  'DamageUp_2A0': '2A0',
  'DamageUp_2AF': '2AF',
  'DamageUp_3D': '3D',
  'DamageUp_489': '489',
  'DamageUp_4C9': '4C9',
  'DamageUp_608': '608',
  'DamageUp_624': '624',
  'DamageUp_638': '638',
  'DamageUp_6E0': '6E0',
  'DamageUp_6E6': '6E6',
  'DamageUp_6EA': '6EA',
  'DamageUp_6F5': '6F5',
  'DamageUp_77F': '77F',
  'DamageUp_8AC': '8AC',
  'DamageUp_95A': '95A',
  'DamageUp_981': '981',
  'DamageUp_9CB': '9CB',
  'DamageUp_9F6': '9F6',
  'DamageUp_C39': 'C39',
  'DamageUp_CBC': 'CBC',
  'DamageUp_DA2': 'DA2',
  'DamageUp_EAC': 'EAC',
  'DamageUp_F87': 'F87',
  'Damnation': 'EF8',
  'DanceOfTheDawn': '10DA',
  'DanceOfTheDawnReady': 'F1D',
  'DancePartner_720': '720',
  'DancePartner_7EB': '7EB',
  'DancingEdge': '1EB',
  'DangerouslyDoped': 'FB6',
  'DarkArts_2F0': '2F0',
  'DarkArts_BDA': 'BDA',
  'DarkDamageUp': '11DB',
  'DarkDance_2E8': '2E8',
  'DarkDance_32D': '32D',
  'DarkDefenses': '1103',
  'DarkForce': '360',
  'DarkMind': '2EA',
  'DarkMissionary_766': '766',
  'DarkMissionary_87B': '87B',
  'DarkResistanceDownIi_13B6': '13B6',
  'DarkResistanceDownIi_CFB': 'CFB',
  'DarkResistanceDown_C40': 'C40',
  'DarkResistanceDown_E23': 'E23',
  'DarkVengeance': '11CF',
  'DarkWhispers_DCF': 'DCF',
  'DarkWhispers_E93': 'E93',
  'DarkenedFire': 'AC9',
  'Darkness': '38A',
  'DarknesssDesign': '1041',
  'DarksAccord': 'DE2',
  'DarksDiscord': 'DE4',
  'Darkside': '2EF',
  'Darksight': '480',
  'Dash': '8F5',
  'DawnsResolve': '1021',
  'Daze': '4',
  'Deactivated': 'B09',
  'DeadMansOverdraught': '1270',
  'DeadlyEmbrace': '1055',
  'DeadlyPhantomAim': '1091',
  'DeathBecomesYou': '895',
  'DeathFromAbove': '650',
  'DeathFromBelow': '651',
  'DeathLink': 'C77',
  'DeathThroes_17A': '17A',
  'DeathThroes_260': '260',
  'DeathWarrant_10D4': '10D4',
  'DeathWarrant_C86': 'C86',
  'DeathsDesign': 'A1A',
  'DeathsToll': 'ACA',
  'Debana': '10D2',
  'DecreeNisiA': '2C3',
  'DecreeNisiB': '2C4',
  'DeepEssenceOfTheVictor': '92D',
  'DeepFreeze_1036': '1036',
  'DeepFreeze_1E7': '1E7',
  'DeepFreeze_47E': '47E',
  'DeepFreeze_4E6': '4E6',
  'DeepFreeze_6C3': '6C3',
  'DeepFreeze_6DE': '6DE',
  'DeepFreeze_8CC': '8CC',
  'DeepFreeze_A62': 'A62',
  'DeepFreeze_C93': 'C93',
  'DeepFreeze_CD7': 'CD7',
  'DeepFreeze_D97': 'D97',
  'DeepFreeze_D98': 'D98',
  'DeepFreeze_D99': 'D99',
  'DeepFreeze_DBF': 'DBF',
  'DefDown': '3C5',
  'DefUp': '3C4',
  'Defamation': '460',
  'Defend': '12B8',
  'DefenseDown': '1E',
  'DefenseKit': '3E1',
  'DefenseUp': '1D',
  'Defenseless': '64C',
  'DefensiveOptimization': '2AA',
  'DefensivePosture': '6ED',
  'DefensiveTactics': '5A1',
  'Defiance_574': '574',
  'Defiance_5B': '5B',
  'Defiance_C34': 'C34',
  'DefyingGravity': '1101',
  'DelayedNeurotoxicity': 'F64',
  'DelightfulRevelation': 'DF3',
  'Delirium_2EC': '2EC',
  'Delirium_7B4': '7B4',
  'Delirium_7CC': '7CC',
  'Delirium_EFC': 'EFC',
  'Deliverance': '2D9',
  'Delusions_F80': 'F80',
  'Delusions_F81': 'F81',
  'DemiclonePenalty': 'DA1',
  'Demolish_51D': '51D',
  'Demolish_F6': 'F6',
  'DemonEye': '1B3',
  'Dervish': '117E',
  'DesignatedConductor': '126F',
  'DesperateMeasures_A97': 'A97',
  'DesperateMeasures_C15': 'C15',
  'DestinyDrawn': 'A0B',
  'Devilment': '721',
  'Devotion': '4BD',
  'Devoured': '1A5',
  'DevouringDark': 'C32',
  'Dia_74F': '74F',
  'Dia_7F3': '7F3',
  'DiabolicCurse': '1A8',
  'Diabrosis': '1182',
  'Diamondback': '6BA',
  'DifferentialDiagnosis': 'A30',
  'Digesting': '285',
  'DigestiveEnzymes': '3BD',
  'DigestiveFluid': '431',
  'DirectAttack_404': '404',
  'DirectAttack_412': '412',
  'DirectAttack_413': '413',
  'DirectAttack_418': '418',
  'DirectedGrotesquerie_128F': '128F',
  'DirectedGrotesquerie_1370': '1370',
  'DirectionalDisregard': 'EE0',
  'DirectionalInvincibility': '465',
  'DirectionalParry': '2A8',
  'DirtyVenom': '42B',
  'Disabled_34C': '34C',
  'Disabled_57D': '57D',
  'DisciplinedFist': 'BB9',
  'Discomposed': 'AAD',
  'Disease_26F': '26F',
  'Disease_45A': '45A',
  'Disease_B5': 'B5',
  'Disease_F67': 'F67',
  'Disembowel_77A': '77A',
  'Disembowel_79': '79',
  'Dismantled': '35C',
  'Displacement_7DD': '7DD',
  'Displacement_CAB': 'CAB',
  'Disseminate': '15C',
  'Dissipation_317': '317',
  'Dissipation_815': '815',
  'Distorted': '9E7',
  'Distracted': '27B',
  'DiurnalBalance_4DF': '4DF',
  'DiurnalBalance_780': '780',
  'DiurnalBalance_7FA': '7FA',
  'DiurnalBenefic': 'C1B',
  'DiurnalIntersection': '760',
  'DiurnalOpposition': '816',
  'DiurnalSect': '347',
  'DiveReady': '4DB',
  'Diversion': '7F',
  'Divination_756': '756',
  'Divination_7F2': '7F2',
  'DivineAura': 'F40',
  'DivineBenison_4C2': '4C2',
  'DivineBenison_57C': '57C',
  'DivineCaress': 'F3F',
  'DivineCommandmentFlee': '590',
  'DivineCommandmentTurn': '591',
  'DivineGrace': 'F29',
  'DivineMight': 'A71',
  'DivineSeal': '9F',
  'DivineVeil_2D6': '2D6',
  'DivineVeil_2D7': '2D7',
  'DivineVeil_552': '552',
  'DivineVeil_878': '878',
  'DivineVeil_879': '879',
  'DivineWill': '12E9',
  'Divining_10EC': '10EC',
  'Divining_F35': 'F35',
  'DivisiveDark': 'EB2',
  'Dizzy': 'B9E',
  'DmoniacBonds': 'DDE',
  'Dokumori_10CF': '10CF',
  'Dokumori_F09': 'F09',
  'Doom_11CE': '11CE',
  'Doom_11F2': '11F2',
  'Doom_124B': '124B',
  'Doom_1440': '1440',
  'Doom_1441': '1441',
  'Doom_1443': '1443',
  'Doom_1561': '1561',
  'Doom_38E': '38E',
  'Doom_6CA': '6CA',
  'Doom_6E9': '6E9',
  'Doom_7B2': '7B2',
  'Doom_9D4': '9D4',
  'Doom_9D7': '9D7',
  'Doom_BA0': 'BA0',
  'Doom_D2': 'D2',
  'Doom_D24': 'D24',
  'Doom_D9A': 'D9A',
  'Doped': 'FB5',
  'DopedAndDetonative': 'FB7',
  'DotonCorruption': 'C07',
  'DotonHeavy': '1F6',
  'Doton_10D0': '10D0',
  'Doton_1F5': '1F5',
  'Doton_C73': 'C73',
  'Double': '295',
  'DoubleEdgeL': '675',
  'DoubledDark': 'EB4',
  'DownAndOut': 'A47',
  'DownForTheCount_1024': '1024',
  'DownForTheCount_10FE': '10FE',
  'DownForTheCount_271': '271',
  'DownForTheCount_306': '306',
  'DownForTheCount_30F': '30F',
  'DownForTheCount_380': '380',
  'DownForTheCount_6E2': '6E2',
  'DownForTheCount_6F9': '6F9',
  'DownForTheCount_79E': '79E',
  'DownForTheCount_7A1': '7A1',
  'DownForTheCount_7AB': '7AB',
  'DownForTheCount_968': '968',
  'DownForTheCount_B5E': 'B5E',
  'DownForTheCount_B91': 'B91',
  'DownForTheCount_C5D': 'C5D',
  'DownForTheCount_DAD': 'DAD',
  'DownForTheCount_E92': 'E92',
  'DownForTheCount_F44': 'F44',
  'DownForTheCount_F8F': 'F8F',
  'DownpourOfDeath': '83',
  'DraconianFire': '747',
  'DraconianGaze': '2BF',
  'DraconianLight': '2C0',
  'DragonForce': '9C4',
  'DragonKick': '62',
  'DragonsFlight': 'F05',
  'DrainedFortitude': '813',
  'DrainedPower': '812',
  'Drainstrikes': '44',
  'DrawFortitude': '810',
  'DrawPower': '80F',
  'DreadwyrmTrance_328': '328',
  'DreadwyrmTrance_C9C': 'C9C',
  'DreamwovenMimicry': '1020',
  'Drenched': '593',
  'DrillPrimed': 'C4E',
  'Drone': 'F51',
  'DropAndRoll': 'E7D',
  'Dropsy_110': '110',
  'Dropsy_11B': '11B',
  'Dropsy_121': '121',
  'Dropsy_1E5': '1E5',
  'Dropsy_213': '213',
  'Dropsy_6C8': '6C8',
  'Dropsy_827': '827',
  'Dropsy_AD6': 'AD6',
  'Dropsy_B69': 'B69',
  'Dropsy_B86': 'B86',
  'Dropsy_C03': 'C03',
  'Dropsy_C04': 'C04',
  'Dropsy_EC1': 'EC1',
  'Dropsy_EC2': 'EC2',
  'Dropsy_ED5': 'ED5',
  'Dropsy_ED6': 'ED6',
  'Drowning': '6A0',
  'DrowningCounter': '3B9',
  'Drubbed': '5EF',
  'DrunkWithPower': 'E0B',
  'Dualcast_4E1': '4E1',
  'Dualcast_562': '562',
  'Dualcast_571': '571',
  'Dualcast_706': '706',
  'Duality': '316',
  'DuelOrDie': '9F1',
  'DuodmoniacBonds': 'DDF',
  'DustPoisoning': '197',
  'DutiesAsAssigned_1084': '1084',
  'DutiesAsAssigned_96F': '96F',
  'DynamicFluid': '641',
  'EarthAndWater': '16F',
  'EarthAspected': 'B02',
  'EarthResistanceDownIi_41D': '41D',
  'EarthResistanceDownIi_831': '831',
  'EarthResistanceDownIi_D2C': 'D2C',
  'EarthResistanceUp': '20C',
  'EarthResonance': 'C63',
  'EarthborneEnd': '1127',
  'EarthenAccord': '30A',
  'EarthenWard': '137',
  'EarthlyDominance': '4C8',
  'EarthsReply': '51F',
  'EarthsResolve': '49C',
  'EarthsRumination': 'F01',
  'EastWindOfChange': '105D',
  'EasterlyWinds': '1516',
  'EatFromTheHand': '164',
  'EchoOfTheFallen': 'CDA',
  'EchoesOfBefoulment': 'BAE',
  'EchoesOfBenevolence': 'BB0',
  'EchoesOfNausea': 'BAD',
  'EchoesOfTheFuture': 'BAF',
  'EdgeOfShadow': '836',
  'EerieAir': '1A9',
  'EggstremeEggAcuity': '1148',
  'Ekpyrosis': 'AB',
  'ElectricalCharge': 'F8B',
  'ElectricalCondenser': 'F9F',
  'Electrified': '8B9',
  'Electroconductivity': '200',
  'Electrocution_10F': '10F',
  'Electrocution_1198': '1198',
  'Electrocution_11E9': '11E9',
  'Electrocution_120': '120',
  'Electrocution_215': '215',
  'Electrocution_29A': '29A',
  'Electrocution_530': '530',
  'Electrocution_76B': '76B',
  'Electrocution_826': '826',
  'Electrocution_898': '898',
  'Electrocution_A56': 'A56',
  'Electrocution_B68': 'B68',
  'Electrocution_B85': 'B85',
  'Electrocution_C01': 'C01',
  'Electrocution_C02': 'C02',
  'Electrocution_EC3': 'EC3',
  'ElectromagneticField': '6A5',
  'ElementalBlessing': '6DC',
  'ElementalBlessingDamage': '5B7',
  'ElementalBlessingExp': '5B5',
  'ElementalExpUp_5A7': '5A7',
  'ElementalExpUp_62F': '62F',
  'ElementalExpUp_6C4': '6C4',
  'ElementalHarmony': '633',
  'ElementalResistanceDown': 'AF1',
  'ElementalStar': '10DD',
  'Elevated': '54E',
  'ElusiveJump': 'C89',
  'ElusiveJumpTarget': 'AC5',
  'Embolden_4D7': '4D7',
  'Embolden_511': '511',
  'Embolden_8EA': '8EA',
  'EmergencyTactics': '318',
  'EmpoweredBeast': 'A59',
  'EmpoweredKetu': '502',
  'EmpoweredRahu': '501',
  'EnAvant': '800',
  'Enaero': 'CE',
  'Enamored': '12C1',
  'Enblizzard': 'CD',
  'EnchainedSoul': 'E01',
  'EnchantedRedoublement_CA4': 'CA4',
  'EnchantedRedoublement_CA7': 'CA7',
  'EnchantedRiposte_CA2': 'CA2',
  'EnchantedRiposte_CA5': 'CA5',
  'EnchantedZwerchhau_CA3': 'CA3',
  'EnchantedZwerchhau_CA6': 'CA6',
  'EncoreOfLightReady': '10D8',
  'EnduringFortitude': '1089',
  'Endwalker': 'AAA',
  'EnergyField': '248',
  'EnergyFieldDown': '249',
  'EnergyLoad': '1205',
  'Enervation_222': '222',
  'Enervation_423': '423',
  'Enervation_579': '579',
  'Enfeebled': '488',
  'Enfire': 'CC',
  'Engagement': '7F1',
  'EnhancedBeneficIi': '32F',
  'EnhancedCrossReaping': 'A1F',
  'EnhancedEggAcuity': '113C',
  'EnhancedEnpi': '4D4',
  'EnhancedFlare': 'B90',
  'EnhancedGallows': 'A1D',
  'EnhancedGibbet_A1C': 'A1C',
  'EnhancedGibbet_B27': 'B27',
  'EnhancedHarpe_B1D': 'B1D',
  'EnhancedHarpe_B2B': 'B2B',
  'EnhancedPiercingTalon': '74E',
  'EnhancedRoyalRoad': '330',
  'EnhancedScatter': '4D5',
  'EnhancedSlugShot': '358',
  'EnhancedUnleash': '32E',
  'EnhancedVoidReaping_A1E': 'A1E',
  'EnhancedVoidReaping_B29': 'B29',
  'EnigmaCodex_862': '862',
  'EnigmaCodex_863': '863',
  'Enlarged_7B7': '7B7',
  'Enlarged_8E8': '8E8',
  'Enliven': '305',
  'EnmityUp': 'D1E',
  'Enochian': '364',
  'Enshielded': '76D',
  'Enshrouded_A21': 'A21',
  'Enshrouded_B2F': 'B2F',
  'Enstone': 'CF',
  'EntangledFlames': 'AC7',
  'Enthunder_9FD': '9FD',
  'Enthunder_D0': 'D0',
  'Entropifaction': 'E08',
  'Entropy': '640',
  'EntropyResistance': 'E21',
  'Enwater': 'D1',
  'EpPenalty': '946',
  'EpicEcho': 'AAE',
  'EpicHero': '1060',
  'EpicVillain': '1061',
  'Epicycle': '10EA',
  'Equilibrium': 'A79',
  'ErraticBlaster': '23E',
  'EscapeDetectionOrdained_867': '867',
  'EscapeDetectionOrdained_BF2': 'BF2',
  'EscapeProhibitionOrdained_866': '866',
  'EscapeProhibitionOrdained_BF1': 'BF1',
  'Esprit_737': '737',
  'Esprit_738': '738',
  'Esprit_7E9': '7E9',
  'Esprit_803': '803',
  'EternalDoom': '45B',
  'Eubuleus': 'AE4',
  'Eudaimonia': 'F3B',
  'Eukrasia_A2E': 'A2E',
  'Eukrasia_B33': 'B33',
  'Eukrasia_C23': 'C23',
  'Eukrasia_F74': 'F74',
  'EukrasianDiagnosis_A2F': 'A2F',
  'EukrasianDiagnosis_B31': 'B31',
  'EukrasianDiagnosis_C25': 'C25',
  'EukrasianDosis': 'A36',
  'EukrasianDosisIi': 'A37',
  'EukrasianDosisIii_A38': 'A38',
  'EukrasianDosisIii_B30': 'B30',
  'EukrasianDosisIii_C24': 'C24',
  'EukrasianDosisIii_F88': 'F88',
  'EukrasianDyskrasia': 'F39',
  'EukrasianPrognosis_A31': 'A31',
  'EukrasianPrognosis_B32': 'B32',
  'EurekaMoment': 'ACD',
  'EvasionDown_20': '20',
  'EvasionDown_963': '963',
  'EvasionUp_1F': '1F',
  'EvasionUp_6AA': '6AA',
  'EvasionUp_962': '962',
  'EventideSword': 'DF6',
  'Everburn': 'D4E',
  'EverlastingFlight_74C': '74C',
  'EverlastingFlight_7EE': '7EE',
  'EverlastingFlight_C9E': 'C9E',
  'EwerDrawn_395': '395',
  'EwerDrawn_C1E': 'C1E',
  'EwerDrawn_FCD': 'FCD',
  'EwerHeld': '39C',
  'Exaltation': 'A9D',
  'ExcavatorReady': 'F19',
  'Excellence': 'CE5',
  'Excogitation_4C4': '4C4',
  'Excogitation_886': '886',
  'Executioner': 'F12',
  'ExecutionersGuillotineReady': '10D3',
  'ExpBonus': '41A',
  'ExpandedAttack': '3D4',
  'ExpandedRoyalRoad': '331',
  'Expedience_A98': 'A98',
  'Expedience_C14': 'C14',
  'Expedience_EE4': 'EE4',
  'Extend': '294',
  'ExtendedRoyalRoad': '332',
  'ExtractorBeamCharged': '1203',
  'ExtremeCaution_46C': '46C',
  'ExtremeCaution_4F5': '4F5',
  'EyeForAnEye_535': '535',
  'EyeForAnEye_536': '536',
  'EyeForAnEye_B9': 'B9',
  'EyeForAnEye_BA': 'BA',
  'EyeGouge': 'BEA',
  'EyeOfTheGorgon': 'D17',
  'EyesOpen': '4E4',
  'FaceInTheCrowd': '5D6',
  'FacilityAccessDetailing': '225',
  'FacilityAccessDetailingIi': '229',
  'FacilityAccessFinishing': '224',
  'FacilityAccessFinishingIi': '22A',
  'FacilityAccessProduction': '223',
  'FacilityAccessProductionIi': '226',
  'FacilityAccessSpecialization': '227',
  'FacilityAccessSpecializationIi': '228',
  'FadedOut': '773',
  'FadingConsciousness': 'AB1',
  'FadingFast': '743',
  'FaeCloak': '47F',
  'FaeLight': '707',
  'Falling': '5C7',
  'FalsePrediction': '10AD',
  'FanDance': '804',
  'FangAndClawBared': '322',
  'Fangbound_457': '457',
  'Fangbound_AD8': 'AD8',
  'FangedMuse': '1010',
  'FantasticalRegeneration': '1296',
  'FarShoreShackles': '1275',
  'FarawayPortent': '129E',
  'FastDraw': '884',
  'FatalAttraction': 'F50',
  'FateOfTheWurm': '12A4',
  'FateParticipant_8DD': '8DD',
  'FateParticipant_A11': 'A11',
  'FatedBrand': '10C6',
  'FatedBurnMark': '1045',
  'FatedHero': '1062',
  'FatedVillain': '1063',
  'Fathom': '48E',
  'Fearless': '6D3',
  'FeatherField': '421',
  'Featherbrained_C31': 'C31',
  'Featherbrained_D85': 'D85',
  'Featherfoot': '63',
  'FeelinHot': '947',
  'Feint_4AB': '4AB',
  'Feint_889': '889',
  'FellhuntersVenom': 'E4B',
  'FellskinsVenom': 'E4C',
  'FemmeFatale': 'F71',
  'FetterWard': '7BF',
  'Fetters_11E2': '11E2',
  'Fetters_124': '124',
  'Fetters_1F8': '1F8',
  'Fetters_1FE': '1FE',
  'Fetters_29B': '29B',
  'Fetters_29C': '29C',
  'Fetters_302': '302',
  'Fetters_320': '320',
  'Fetters_336': '336',
  'Fetters_385': '385',
  'Fetters_3A2': '3A2',
  'Fetters_3DE': '3DE',
  'Fetters_3F2': '3F2',
  'Fetters_41F': '41F',
  'Fetters_481': '481',
  'Fetters_4EA': '4EA',
  'Fetters_56F': '56F',
  'Fetters_577': '577',
  'Fetters_5B4': '5B4',
  'Fetters_5C5': '5C5',
  'Fetters_5D9': '5D9',
  'Fetters_64E': '64E',
  'Fetters_6BE': '6BE',
  'Fetters_6DD': '6DD',
  'Fetters_739': '739',
  'Fetters_774': '774',
  'Fetters_8ED': '8ED',
  'Fetters_8EE': '8EE',
  'Fetters_967': '967',
  'Fetters_B9F': 'B9F',
  'Fetters_CB1': 'CB1',
  'Fetters_CD3': 'CD3',
  'Fetters_CFC': 'CFC',
  'Fetters_D5D': 'D5D',
  'Fetters_DE0': 'DE0',
  'Fetters_EAB': 'EAB',
  'Fever': 'B7',
  'FeverReversed': 'D3C',
  'FeyCovenant': '13C',
  'FeyFire': '167',
  'FeyGlow': '13E',
  'FeyIllumination': '13D',
  'FeyLight': '13F',
  'FeyUnion_4C6': '4C6',
  'FeyUnion_4C7': '4C7',
  'FeyWind': '31F',
  'FieryConception': 'D0C',
  'FifthChakra': '31D',
  'FightOrFlight': '4C',
  'Filthy': '5C2',
  'FinalAppraisal': '88E',
  'FinalDecreeNisiA': '405',
  'FinalDecreeNisiB': '406',
  'FinalDecreeNisi_859': '859',
  'FinalDecreeNisi_85A': '85A',
  'FinalDecreeNisi_8AE': '8AE',
  'FinalDecreeNisi_8AF': '8AF',
  'FinalFantasia': 'C48',
  'FinalFlight': '40E',
  'FinalJudgmentDecreeNisiA': '40C',
  'FinalJudgmentDecreeNisiB': '40D',
  'FinalJudgmentDecreeNisi_85B': '85B',
  'FinalJudgmentDecreeNisi_85C': '85C',
  'FinalJudgmentDecreeNisi_8B0': '8B0',
  'FinalJudgmentDecreeNisi_8B1': '8B1',
  'FinalJudgmentMaxHp': '407',
  'FinalJudgmentMinHp': '408',
  'FinalJudgmentPenaltyI': '409',
  'FinalJudgmentPenaltyIi': '40A',
  'FinalJudgmentPenaltyIii_40B': '40B',
  'FinalJudgmentPenaltyIii_8AD': '8AD',
  'FinalJudgmentPenaltyIv': '85D',
  'FinalPunishment': '403',
  'FinalWordContactProhibition': '868',
  'FinalWordContactRegulation': '869',
  'FinalWordEscapeDetection': '86B',
  'FinalWordEscapeProhibition': '86A',
  'FinishingFervor': '12B9',
  'FinishingMoveReady': 'F1C',
  'FireAlchemy': 'ABF',
  'FireCharged': '5CB',
  'FireConvergence': '4FB',
  'FireDamageUp': '11DA',
  'FireLoaded': 'E2A',
  'FireResistanceDownIi_111F': '111F',
  'FireResistanceDownIi_13B5': '13B5',
  'FireResistanceDownIi_471': '471',
  'FireResistanceDownIi_4E7': '4E7',
  'FireResistanceDownIi_832': '832',
  'FireResistanceDownIi_B56': 'B56',
  'FireResistanceDownIi_B79': 'B79',
  'FireResistanceDown_26D': '26D',
  'FireResistanceDown_29E': '29E',
  'FireResistanceUp_1167': '1167',
  'FireResistanceUp_208': '208',
  'FireResistanceUp_5ED': '5ED',
  'FireResonance': 'C62',
  'FireToad': '1FF',
  'FirebirdTrance': 'C9D',
  'FiresRumination_10CD': '10CD',
  'FiresRumination_F03': 'F03',
  'Firescorched': '1D0',
  'Firesnaking': '136E',
  'Firestarter': 'A5',
  'Firestream': '14F',
  'FirstBrand': 'CC4',
  'FirstChakra': '319',
  'FirstFlame': 'CC8',
  'FirstInLine': 'BBC',
  'FirstmindsFocus': 'C6A',
  'FishEyes': '2FA',
  'FishersIntuition': '238',
  'FistsOfEarth_68': '68',
  'FistsOfEarth_7D6': '7D6',
  'FistsOfFire_67': '67',
  'FistsOfFire_7D5': '7D5',
  'FistsOfWind': '69',
  'FixedSign_A4F': 'A4F',
  'FixedSign_A50': 'A50',
  'FixedSign_A51': 'A51',
  'FizzlingSuds_CE3': 'CE3',
  'FizzlingSuds_CEB': 'CEB',
  'FlamesOfEventide': 'DF5',
  'Flamespire_D9E': 'D9E',
  'Flamespire_D9F': 'D9F',
  'FlamethrowerFlames': '5B2',
  'Flamethrower_4B5': '4B5',
  'Flamethrower_5AF': '5AF',
  'FlamingArrow': 'F9',
  'FlanksbaneVenom': 'E3E',
  'FlankstungVenom': 'E3D',
  'FlareDampening': '255',
  'FleetFooted': 'B74',
  'Fleetfooted': '108F',
  'FleetingRaijuReady_A83': 'A83',
  'FleetingRaijuReady_C8B': 'C8B',
  'FleshBack_128C': '128C',
  'FleshBack_1298': '1298',
  'FleshForward_128B': '128B',
  'FleshForward_1297': '1297',
  'FleshWound_108': '108',
  'FleshWound_270': '270',
  'FleshWound_715': '715',
  'FleshWound_81F': '81F',
  'FleshWound_B61': 'B61',
  'FleshWound_B7E': 'B7E',
  'FleshWound_BF3': 'BF3',
  'FleshWound_BF4': 'BF4',
  'FloatingFetters_119D': '119D',
  'FloatingFetters_900': '900',
  'FloodOfShadow': '87A',
  'FlourishingCascade': '716',
  'FlourishingFanDance': '7E5',
  'FlourishingFinish': 'A8A',
  'FlourishingFlow': 'BCA',
  'FlourishingFountain': '717',
  'FlourishingSaberDance': 'C58',
  'FlourishingShower': '719',
  'FlourishingStarfall': 'A8C',
  'FlourishingSymmetry': 'BC9',
  'FlourishingWindmill': '718',
  'FlyingHigh': '6C2',
  'FoamyFetters': 'ECC',
  'Focalization': '818',
  'FoeRequiem_8B': '8B',
  'FoeRequiem_8C': '8C',
  'FoolsFigure': '184',
  'FoolsTightrope': '181',
  'FoolsTumble': '183',
  'ForbiddenPassage_CCE': 'CCE',
  'ForbiddenPassage_CCF': 'CCF',
  'ForceAgainstMagic': '3EE',
  'ForceAgainstMight': '3ED',
  'ForcedMarch_1436': '1436',
  'ForcedMarch_4E9': '4E9',
  'ForcedMarch_E2D': 'E2D',
  'ForcedMarch_E87': 'E87',
  'ForcedMarch_E99': 'E99',
  'ForcedWithdrawal': '3D1',
  'ForeMarkOfTheTides': 'AD2',
  'ForeseenOffense': '10B6',
  'Foresight': '53',
  'ForkedLightning_24B': '24B',
  'ForkedLightning_ED7': 'ED7',
  'FormlessFist': '9D1',
  'Forte': '10E0',
  'FortifiedRecuperation': '10B0',
  'ForwardBearing': 'B13',
  'ForwardMarch_1448': '1448',
  'ForwardMarch_50D': '50D',
  'ForwardMarch_7A6': '7A6',
  'ForwardMarch_871': '871',
  'ForwardMarch_94D': '94D',
  'ForwardMarch_DD2': 'DD2',
  'ForwardMarch_E72': 'E72',
  'ForwardMarch_E83': 'E83',
  'ForwardOmen_1039': '1039',
  'ForwardOmen_1141': '1141',
  'ForwardOmen_1145': '1145',
  'ForwardOmen_114A': '114A',
  'ForwardWhimsy': 'B8E',
  'ForwardWithThee': '8C0',
  'FountainOfFire_7ED': '7ED',
  'FountainOfFire_B70': 'B70',
  'FourCrossedMemory': 'FD1',
  'FourSwipeMemory': 'FD4',
  'FourfoldComeRuin': 'E6F',
  'FourfoldFanDance': 'A8B',
  'FourthBrand': 'CC7',
  'FourthChakra': '31C',
  'FourthFlame': 'CCB',
  'FourthInLine': 'D7B',
  'Fracture': 'F4',
  'FracturedMettle': 'FC3',
  'Frazzle': 'CA9',
  'Freecure': '9B',
  'FreezingBrand': '851',
  'FreezingCounter': '3B6',
  'FreezingUp_9EC': '9EC',
  'FreezingUp_DC3': 'DC3',
  'Freezing_8CB': '8CB',
  'Freezing_B53': 'B53',
  'Frenzied': '278',
  'FreshPerspective': '94B',
  'FrogtourageFan': 'F9E',
  'FrontUnseen_A54': 'A54',
  'FrontUnseen_E8E': 'E8E',
  'FrontalBlasterCharge': 'D8C',
  'FrontlineForte': 'C45',
  'FrontlineMarch': 'C43',
  'FrontlinersForte': 'C44',
  'FrontlinersMarch': 'C42',
  'FrostBlade': '20E',
  'FrostBow': '210',
  'FrostBrand': '20F',
  'Frostbite_10C': '10C',
  'Frostbite_11D': '11D',
  'Frostbite_217': '217',
  'Frostbite_25D': '25D',
  'Frostbite_6FC': '6FC',
  'Frostbite_823': '823',
  'Frostbite_B65': 'B65',
  'Frostbite_B82': 'B82',
  'Frostbite_BFB': 'BFB',
  'Frostbite_BFC': 'BFC',
  'FrownyFace': 'ACC',
  'Frozen_25E': '25E',
  'Frozen_CD6': 'CD6',
  'Fugetsu': '512',
  'FugitiveFromJustice': '11C6',
  'Fuka': '513',
  'FullGrown_180': '180',
  'FullGrown_187': '187',
  'FullGrown_ECA': 'ECA',
  'FullMetalMachinist': 'F1A',
  'FullMoon': '5FF',
  'FullSwing': '7B9',
  'FullyAnalyzed': '935',
  'FullyEnlarged_7B8': '7B8',
  'FullyEnlarged_8E9': '8E9',
  'FuriousWelt': 'D9C',
  'FurtherRuin_112F': '112F',
  'FurtherRuin_4BC': '4BC',
  'FurtherRuin_A8D': 'A8D',
  'Fury_10FD': '10FD',
  'Fury_1213': '1213',
  'Fury_EDD': 'EDD',
  'FurysBolt': '8B7',
  'Fusefield': 'CD9',
  'GadgetResistance_3CD': '3CD',
  'GadgetResistance_3D9': '3D9',
  'GaleEnforcer': '74D',
  'GallowsOiled': 'B28',
  'Galvanize_129': '129',
  'Galvanize_533': '533',
  'Galvanize_C0F': 'C0F',
  'Garrote': '1CF',
  'GarroteTwist': '1CE',
  'GarudasFavor': 'AA5',
  'GatherersBounty': 'A6B',
  'GatherersGrace': '2E',
  'GatheringFortuneUp': 'DC',
  'GatheringFortuneUpIi': '505',
  'GatheringFortuneUpIiLimited': '4EE',
  'GatheringFortuneUpLimited': '2F3',
  'GatheringRateUp': 'DA',
  'GatheringRateUpLimited': '2F2',
  'GatheringYieldUp': 'DB',
  'GatheringYieldUpIi': '506',
  'GatheringYieldUpLimited': '2F4',
  'GauntletTaken_14ED': '14ED',
  'GauntletTaken_14EE': '14EE',
  'GauntletTaken_14EF': '14EF',
  'GauntletTaken_14F0': '14F0',
  'GauntletTaken_14F1': '14F1',
  'GauntletTaken_14F2': '14F2',
  'GauntletTaken_14F3': '14F3',
  'GauntletTaken_14F4': '14F4',
  'GauntletThrown_14F5': '14F5',
  'GauntletThrown_14F6': '14F6',
  'GauntletThrown_14F7': '14F7',
  'GauntletThrown_14F8': '14F8',
  'GauntletThrown_14F9': '14F9',
  'GauntletThrown_14FA': '14FA',
  'GauntletThrown_14FB': '14FB',
  'GauntletThrown_14FC': '14FC',
  'GaussBarrel': '35A',
  'Gelatinous': '9EF',
  'GelidGaol': '10EF',
  'GhostlyGuise_102B': '102B',
  'GhostlyGuise_F6D': 'F6D',
  'GiantDominance': '4E0',
  'GiftOfTheLand': 'A6A',
  'GiftOfTheLandIi': '2F7',
  'GildedFate': 'CDF',
  'GlassyEyed': 'DB7',
  'Gloam': '1DC',
  'GlossalResistanceDown': 'CF7',
  'Glossomorph_CF2': 'CF2',
  'Glossomorph_CFA': 'CFA',
  'Glossomorph_D48': 'D48',
  'GlovesOff': 'D82',
  'GloweringDark': 'EB5',
  'GnashingWolf': 'B93',
  'Goad': '1EF',
  'GoblixerGrumblygut': '3EA',
  'GoblixerOvergulp': '3E9',
  'Gobskin': '842',
  'GokaMekkyaku': 'C70',
  'GoldLung': '12E',
  'GoldSaucerVipCard': '437',
  'Goldbile': '127',
  'GoldenEye': '113D',
  'GoringBlade': '2D5',
  'GoringBladeReady': 'F07',
  'GraceOfLight': '8D6',
  'GradualPetrification_54F': '54F',
  'GradualPetrification_65C': '65C',
  'GradualZombification': '415',
  'GrandImpactReady': 'F25',
  'GravitationalAnomaly_EBA': 'EBA',
  'GravitationalAnomaly_EE6': 'EE6',
  'GravitationalStability': '117B',
  'GravityFlip': '54D',
  'GreasedLightning': '6F',
  'GreasedLightningIi': '70',
  'GreasedLightningIii': '71',
  'GreatNebula': 'EFE',
  'GreatStrides': 'FE',
  'GreaterReachReady': '1155',
  'GreatestCurse': 'EF1',
  'Greenwrath': '144',
  'GrimhuntersVenom': 'E41',
  'GrimskinsVenom': 'E42',
  'GripOfDespair': 'BB1',
  'Grit_2E7': '2E7',
  'Grit_575': '575',
  'GroundSupport': '1086',
  'Grounded': '588',
  'GroupOriented': '698',
  'GrowingConception': 'D0E',
  'Growing_17F': '17F',
  'Growing_186': '186',
  'Grudge': '625',
  'GuardOnDuty_11C2': '11C2',
  'GuardOnDuty_11C3': '11C3',
  'GuardOnDuty_11C4': '11C4',
  'GuardOnDuty_11C5': '11C5',
  'Guard_BEE': 'BEE',
  'Guard_E59': 'E59',
  'Guardian': 'EF5',
  'GuardianSpirit': '69C',
  'GuardianWill': '11DE',
  'GuardiansAegis': '6D4',
  'GuardiansWill': 'EF6',
  'GuidedMissileKyriosIncoming_D60': 'D60',
  'GuidedMissileKyriosIncoming_DA7': 'DA7',
  'GuidedMissileKyriosIncoming_DA8': 'DA8',
  'GuidedMissileKyriosIncoming_DA9': 'DA9',
  'Guise': 'A13',
  'Gullstorm': 'A08',
  'Gungnir': '141',
  'GunmetalSoul': '78B',
  'Haima_A34': 'A34',
  'Haima_B35': 'B35',
  'Haima_C26': 'C26',
  'Haimatinon_A52': 'A52',
  'Haimatinon_B36': 'B36',
  'Haimatinon_C27': 'C27',
  'HalfAsleep': 'BCE',
  'HallowedGround_516': '516',
  'HallowedGround_52': '52',
  'HammerTime': 'E60',
  'HardMarked': '2B6',
  'HardWorker': '11CB',
  'Hardcore': 'BB2',
  'HardenedScales': '1000',
  'HarderWorker': '11CC',
  'HardestWorker': '11CD',
  'Harmonized': '846',
  'HarmonyOfBody': 'A9B',
  'HarmonyOfMind': 'A9C',
  'HarmonyOfSpirit': 'A9A',
  'Harvest': '252',
  'Haste_1025': '1025',
  'Haste_126E': '126E',
  'Haste_14A': '14A',
  'Haste_1AC': '1AC',
  'Haste_1E0': '1E0',
  'Haste_28B': '28B',
  'Haste_443': '443',
  'Haste_45C': '45C',
  'Haste_5F3': '5F3',
  'Haste_7AA': '7AA',
  'Haste_8': '8',
  'Haste_94A': '94A',
  'Haste_E2': 'E2',
  'HastiludeHeartened': '92F',
  'Hastilude_797': '797',
  'Hastilude_92E': '92E',
  'HastyMirage': '109F',
  'HatedOfEmbers': '8BC',
  'HatedOfFrost': '8D4',
  'HatedOfLevin': '8C5',
  'HatedOfTheVortex': '8BB',
  'HatedOfTheWyrm': '8D5',
  'Haunt_606': '606',
  'Haunt_607': '607',
  'HawksEye_7B': '7B',
  'HawksEye_F15': 'F15',
  'HeadInTheClouds_9A7': '9A7',
  'HeadInTheClouds_9A8': '9A8',
  'HeadOverHeels_F4E': 'F4E',
  'HeadOverHeels_F54': 'F54',
  'Headache': '3E3',
  'Headwind': '642',
  'HealingGlyph': '14EB',
  'HealingMagicDown_1A6': '1A6',
  'HealingMagicDown_2B9': '2B9',
  'HealingMagicDown_82D': '82D',
  'HealingPotencyDown_24': '24',
  'HealingPotencyDown_3A5': '3A5',
  'HealingPotencyDown_427': '427',
  'HealingPotencyUp_23': '23',
  'HealingPotencyUp_3BB': '3BB',
  'HealingPotencyUp_44B': '44B',
  'HeartAndSoul': 'A69',
  'HeartOfCorundum_10C7': '10C7',
  'HeartOfCorundum_A7B': 'A7B',
  'HeartOfDragon': '434',
  'HeartOfLight_72F': '72F',
  'HeartOfLight_7D0': '7D0',
  'HeartOfMan_433': '433',
  'HeartOfMan_ABA': 'ABA',
  'HeartOfStone': '730',
  'HeartOfTheMountain': '148',
  'HeartOfTheRroneek': 'F6F',
  'HeartOfTural': 'F72',
  'Heartless': '613',
  'Heat': 'C4C',
  'HeatWave': 'EAA',
  'HeatedUp_702': '702',
  'HeatedUp_703': '703',
  'HeatingUp': '1166',
  'Heatstroke': '102D',
  'HeavenlyShield': '6C7',
  'Heavensent': 'C68',
  'HeavensflameSoul': 'DFA',
  'HeavyFeet': '2C5',
  'HeavyMedal_426': '426',
  'HeavyMedal_5DB': '5DB',
  'HeavyMedal_5DC': '5DC',
  'HeavyMedal_5DD': '5DD',
  'HeavyMedal_5DE': '5DE',
  'HeavyResistance': '546',
  'HeavySoulSnare': 'DDC',
  'HeavyThrust': '73',
  'Heavy_10F5': '10F5',
  'Heavy_13B4': '13B4',
  'Heavy_276': '276',
  'Heavy_453': '453',
  'Heavy_475': '475',
  'Heavy_540': '540',
  'Heavy_63B': '63B',
  'Heavy_704': '704',
  'Heavy_833': '833',
  'Heavy_86E': '86E',
  'Heavy_957': '957',
  'Heavy_9F7': '9F7',
  'Heavy_C5F': 'C5F',
  'Heavy_D90': 'D90',
  'Heavy_D91': 'D91',
  'Heavy_E': 'E',
  'Heavy_F0': 'F0',
  'HeelOfTheCell_1283': '1283',
  'HeelOfTheCell_1284': '1284',
  'HeelOfTheCell_1285': '1285',
  'HeelOfTheCell_1286': '1286',
  'HeelOfTheCell_1287': '1287',
  'HeelOfTheCell_1288': '1288',
  'HeelOfTheCell_1289': '1289',
  'HeelOfTheCell_128A': '128A',
  'HeightenedVisibility': '397',
  'HeliosConjunction': 'F36',
  'HellAwaits': '127A',
  'HellInACell_127B': '127B',
  'HellInACell_127C': '127C',
  'HellInACell_127D': '127D',
  'HellInACell_127E': '127E',
  'HellInACell_127F': '127F',
  'HellInACell_1280': '1280',
  'HellInACell_1281': '1281',
  'HellInACell_1282': '1282',
  'HellishConduit': '74B',
  'HellishEarth': '11D6',
  'HelloDistantWorld': 'D73',
  'HelloNearWorld': 'D72',
  'HellsIngress': 'C87',
  'HelpingHand': '170',
  'Herbsona': '9C9',
  'HeroesFantasia': 'C49',
  'HerosLament': '109A',
  'HerosRime': '1099',
  'HerossMantle': 'B3C',
  'Hidden_266': '266',
  'Hidden_267': '267',
  'Hidden_454': '454',
  'Hidden_524': '524',
  'Hidden_6A9': '6A9',
  'Hide': '7A0',
  'Higanbana_4CC': '4CC',
  'Higanbana_527': '527',
  'HighAndMighty': '1D5',
  'HighArithmeticks': '3FE',
  'HighJumpTarget': 'AC3',
  'HighMorale': '93D',
  'HighPoweredSniperCannonFodder': 'D62',
  'HighThunder_F1F': 'F1F',
  'HighThunder_F20': 'F20',
  'HighWire_3F4': '3F4',
  'HighWire_F79': 'F79',
  'Higi': 'F0A',
  'HindsbaneVenom': 'E40',
  'HindstungVenom': 'E3F',
  'Holmgang_199': '199',
  'Holmgang_518': '518',
  'Holmgang_519': '519',
  'Holmgang_58': '58',
  'Holos': 'BBB',
  'Holosakos': 'D25',
  'HolyBonds_CED': 'CED',
  'HolyBonds_D46': 'D46',
  'HolyPurgation_CEF': 'CEF',
  'HolyPurgation_D42': 'D42',
  'HolyPurgation_D43': 'D43',
  'HolyPurgation_D44': 'D44',
  'HolySheltron_A72': 'A72',
  'HolySheltron_BD2': 'BD2',
  'HonedEye': 'E1E',
  'HonedReavers': 'EBC',
  'HonedSpellblade': '12B5',
  'HonedSteel': 'E58',
  'HoneyBeeMine': 'F56',
  'HoneyGlazed': '1BE',
  'HoneyedCharms': 'F61',
  'HoningDance': 'C5A',
  'HoningOvation': 'C5C',
  'HonorsAccord': '1026',
  'HoofingIt_6F2': '6F2',
  'HoofingIt_799': '799',
  'HoofingIt_E24': 'E24',
  'HopelessDevotion_F4F': 'F4F',
  'HopelessDevotion_F55': 'F55',
  'Horoscope': '762',
  'HoroscopeHelios': '763',
  'HorridRoar': 'C6B',
  'HotBlade1': '8F9',
  'HotBlade2': '8FA',
  'HotBlooded': '12A0',
  'HotBrand1': '8E5',
  'HotBrand2': '8F3',
  'HotShot': '357',
  'HotSpell': 'AB4',
  'HouseArrest': '463',
  'Hover_19C': '19C',
  'Hover_5EB': '5EB',
  'Hover_956': '956',
  'HpBoost1': '616',
  'HpBoost2': '617',
  'HpBoost3': '618',
  'HpBoost4': '619',
  'HpBoost_1266': '1266',
  'HpBoost_15': '15',
  'HpBoost_1E3': '1E3',
  'HpBoost_24A': '24A',
  'HpBoost_6E3': '6E3',
  'HpBoost_848': '848',
  'HpMpBoost_28C': '28C',
  'HpMpBoost_445': '445',
  'HpPenalty_16': '16',
  'HpPenalty_1C8': '1C8',
  'HpPenalty_441': '441',
  'HpPenalty_567': '567',
  'HpPenalty_615': '615',
  'HpPenalty_9D9': '9D9',
  'HpPenalty_B9B': 'B9B',
  'HpPenalty_D49': 'D49',
  'HpRecoveryDown_B24': 'B24',
  'HpRecoveryDown_BA1': 'BA1',
  'HpRecoveryDown_BA2': 'BA2',
  'HpRecoveryDown_F7F': 'F7F',
  'Hubris': 'A2B',
  'HuffyCat': '1169',
  'HundredFists_123': '123',
  'HundredFists_63A': '63A',
  'HungryForVictory': '11A5',
  'HuntersInstinct_1018': '1018',
  'HuntersInstinct_E54': 'E54',
  'HuntersVenom': 'E49',
  'Huton_1F4': '1F4',
  'Huton_C72': 'C72',
  'Huton_E20': 'E20',
  'HydrobulletTarget_1368': '1368',
  'HydrobulletTarget_EA4': 'EA4',
  'HydrofallTarget': 'EA3',
  'Hypercharge': '2B0',
  'Hypercharged': 'F18',
  'HyperchargedCondensation': '951',
  'Hyperphantasia': 'E68',
  'Hypervelocity': 'BE7',
  'Hysteria_1047': '1047',
  'Hysteria_128': '128',
  'Hysteria_BCF': 'BCF',
  'IceAegis': '1081',
  'IceAlchemy': 'AC0',
  'IceCharge': '147',
  'IceConvergence': '4FC',
  'IceLoaded': 'E2B',
  'IceOoze': '115A',
  'IceResistanceDown': '6A6',
  'IceResistanceDownIi_9A1': '9A1',
  'IceResistanceDownIi_B57': 'B57',
  'IceResistanceUp_20D': '20D',
  'IceResistanceUp_6E1': '6E1',
  'IceSpikes_51B': '51B',
  'IceSpikes_6B8': '6B8',
  'IceSpikes_9E0': '9E0',
  'IceSpikes_C6': 'C6',
  'Icebitten': '1D1',
  'IceboundBuffoonery': '115B',
  'IdealHost': 'F41',
  'IdenticalCast': '70C',
  'IdenticalGig': '70D',
  'IfritsFavor': 'AA4',
  'ImbuedSaber': '949',
  'Immaterialized': '55D',
  'ImmortalConception': 'D10',
  'ImmortalSacrifice_A20': 'A20',
  'ImmortalSacrifice_C84': 'C84',
  'ImmortalSpark': 'D0F',
  'Imp_265': '265',
  'Imp_44F': '44F',
  'Imp_46E': '46E',
  'Imp_54C': '54C',
  'ImpactImminent': 'F2A',
  'Impactful': '557',
  'Impassioned': 'EAF',
  'ImperfectionAlpha': 'D02',
  'ImperfectionBeta': 'D03',
  'ImperfectionGamma': 'D04',
  'Impervious': '455',
  'ImposingFigure': 'E1F',
  'Improvisation_723': '723',
  'Improvisation_724': '724',
  'Improvisation_A87': 'A87',
  'ImprovisedFinish': 'A89',
  'InControl': '165',
  'InCostume': '8E4',
  'InEvent_136D': '136D',
  'InEvent_4F4': '4F4',
  'InEvent_791': '791',
  'InEvent_B23': 'B23',
  'InEvent_B75': 'B75',
  'InEvent_BB7': 'BB7',
  'InTheHeadlights': '242',
  'InTheLineOfFire': '23A',
  'InTheSpotlight': '1177',
  'InTheWeeds': '1214',
  'InTraining': '1057',
  'Incapacitated': 'B08',
  'IncapacitatingSoulSnare': 'DDD',
  'IncendiaryBurns': '9C3',
  'IncenseL': '679',
  'IncensePenalty': '11EF',
  'Inconceivable': 'D08',
  'Incorporeal': 'AA9',
  'Incurable_5D0': '5D0',
  'Incurable_95E': '95E',
  'IndependentTactics': '59F',
  'IndomitableSpirit': '60B',
  'InefficientHooking': '2FC',
  'InescapableCompanionship': 'AB8',
  'InescapableLoneliness': 'AB9',
  'Infatuated_F4D': 'F4D',
  'Infatuated_F53': 'F53',
  'InfernalFetters': '179',
  'InfernalShroud': 'EBB',
  'Inferno': '13A',
  'InfiniteAnguish_487': '487',
  'InfiniteAnguish_48A': '48A',
  'InfiniteFire': '477',
  'InfiniteIce': '478',
  'InfiniteLimit_67B': '67B',
  'InfiniteLimit_D7A': 'D7A',
  'Infirmity_1F2': '1F2',
  'Infirmity_275': '275',
  'Infirmity_9D8': '9D8',
  'Infirmity_AC': 'AC',
  'Infirmity_F7D': 'F7D',
  'Infuriated': '61',
  'Ingenuity': 'FF',
  'IngenuityIi': '100',
  'InitialPreparations': '48D',
  'Ink': '1E4',
  'InnerBeast_19B': '19B',
  'InnerBeast_576': '576',
  'InnerChaos': '81D',
  'InnerChaosReady': '10BC',
  'InnerDarkness': '1051',
  'InnerDragon': '132',
  'InnerQuiet': 'FB',
  'InnerRelease_499': '499',
  'InnerRelease_517': '517',
  'InnerStrength': 'A67',
  'Innovation_103': '103',
  'Innovation_88D': '88D',
  'Inscribed': 'E94',
  'Insensible': '11C9',
  'Inspiration': 'E69',
  'Intemperate': '8E3',
  'IntensifiedWailing': 'DEC',
  'InternalRelease': '64',
  'Intersection_761': '761',
  'Intersection_FC8': 'FC8',
  'Intervention_496': '496',
  'Intervention_7E4': '7E4',
  'InugamisFavor': '631',
  'InverseMagicks': 'D15',
  'InverseOperations': 'FA9',
  'Invigoration': '263',
  'Invincibility_113A': '113A',
  'Invincibility_11BB': '11BB',
  'Invincibility_145': '145',
  'Invincibility_18A': '18A',
  'Invincibility_211': '211',
  'Invincibility_290': '290',
  'Invincibility_29F': '29F',
  'Invincibility_307': '307',
  'Invincibility_308': '308',
  'Invincibility_37F': '37F',
  'Invincibility_3C9': '3C9',
  'Invincibility_3D5': '3D5',
  'Invincibility_622': '622',
  'Invincibility_6A1': '6A1',
  'Invincibility_725': '725',
  'InviolateWinds_CEC': 'CEC',
  'InviolateWinds_D45': 'D45',
  'Invisible_268': '268',
  'Invisible_3EF': '3EF',
  'Invulnerability': '10B3',
  'IrminHedge': 'B0B',
  'IronAir': '9BB',
  'IronCarrot': 'AF8',
  'IronWill_189': '189',
  'IronWill_4F': '4F',
  'IronWill_B1B': 'B1B',
  'IronsOfPurgatory': '8BD',
  'Irradiated': '269',
  'ItemPenalty': '446',
  'Jackpot': '386',
  'JealousAnaphylaxis': '8FE',
  'JestersAntics': '5CE',
  'JestersTruths': '5CF',
  'Jitterbugged': '12BC',
  'Jog': '1071',
  'JugularRip': 'BE8',
  'JunctionDps': 'BE5',
  'JunctionHealer': 'BE6',
  'JunctionLoghrif': '9A6',
  'JunctionShiva': '9A4',
  'JunctionTank': 'BE4',
  'JunctionTitan': '9A5',
  'JustChilling': 'A2A',
  'KaeshiNamikiri': 'C80',
  'Kaiten_4CD': '4CD',
  'Kaiten_C81': 'C81',
  'Kakuremi': '523',
  'Kardia_A2C': 'A2C',
  'Kardia_B37': 'B37',
  'Kardion_A2D': 'A2D',
  'Kardion_B38': 'B38',
  'Kassatsu': '1F1',
  'Katabasis': 'A6E',
  'KeenEdge': '479',
  'KeenFlurry': '72',
  'Kerachole': 'A3A',
  'Kerakeia': 'B7A',
  'KillCommand': '65D',
  'KingOfTheSkies': '5EE',
  'KissOfTheViper': '1EA',
  'KissOfTheWasp': '1E9',
  'Klymenos': 'A6D',
  'KnightsBenediction': 'A74',
  'KnightsResolve': 'A73',
  'KnockbackPenalty_448': '448',
  'KnockbackPenalty_54B': '54B',
  'KnockbackPenalty_5E8': '5E8',
  'KomainusFavor': '630',
  'Krasis': 'A3E',
  'KunaisBane': 'F42',
  'Kuzushi': 'C82',
  'Kyoshin': '560',
  'LadyOfCrownsDrawn': '807',
  'LadyOfCrowns_10E8': '10E8',
  'LadyOfCrowns_5AC': '5AC',
  'LadyOfCrowns_755': '755',
  'Lamed': '279',
  'LamentOfTheClose': '112C',
  'LamentOfTheDistant': '112D',
  'LanceCharge_748': '748',
  'LanceCharge_CBA': 'CBA',
  'LandWaker': '35F',
  'Landborne_64A': '64A',
  'Landborne_69B': '69B',
  'Languishing': '1C7',
  'Largesse_4B7': '4B7',
  'Largesse_88C': '88C',
  'LastBastion': 'C4',
  'LastDanceReady': 'F1B',
  'LastKiss': '5BF',
  'LastVigil_B0D': 'B0D',
  'LastVigil_B0E': 'B0E',
  'LatentDefect_686': '686',
  'LatentDefect_DC7': 'DC7',
  'LatentPerformanceDefect': 'D6B',
  'LatentSynchronizationBug': 'D6A',
  'LayOfTheLand': 'EA',
  'LayOfTheLandIi': 'F3',
  'LeadShot': '356',
  'Leaden': '43',
  'LeadenFist': '745',
  'LeftArmOperational': '46B',
  'LeftArmPrimed': 'A10',
  'LeftArmReassembly': '468',
  'LeftBlasterCharge': 'D8E',
  'LeftEye_4A0': '4A0',
  'LeftEye_5AE': '5AE',
  'LeftFace_144A': '144A',
  'LeftFace_50F': '50F',
  'LeftFace_7A8': '7A8',
  'LeftFace_873': '873',
  'LeftFace_94F': '94F',
  'LeftFace_DD4': 'DD4',
  'LeftFace_E74': 'E74',
  'LeftFace_E85': 'E85',
  'LeftMarkOfTheTides': 'AD4',
  'LeftUnseen_6AC': '6AC',
  'LeftUnseen_E91': 'E91',
  'LeftWindup_FBD': 'FBD',
  'LeftWindup_FBF': 'FBF',
  'LeftWithThee': '8C2',
  'LeftwardBearing': 'B15',
  'LeftwardFracture': 'FC5',
  'LeftwardMemory': 'FD3',
  'LeftwardOmen_1037': '1037',
  'LeftwardOmen_103B': '103B',
  'LeftwardOmen_1143': '1143',
  'LeftwardOmen_1147': '1147',
  'LeftwardOmen_114C': '114C',
  'LeftwardOmen_114E': '114E',
  'LeftwardWhimsy': 'B19',
  'LegendaryResolve': '596',
  'LegsOfTheSpider': '3B2',
  'Lethargy': '10ED',
  'LeveilleurDosisIii': 'A5A',
  'Levinskin': '788',
  'Levitate': 'F86',
  'Levitation_107B': '107B',
  'Levitation_556': '556',
  'Levitation_56E': '56E',
  'Levitation_C': 'C',
  'LeyLines': '2E1',
  'LifeDrain_111C': '111C',
  'LifeDrain_561': '561',
  'LifeOfTheDragon': 'C69',
  'LifeSiphon': '101B',
  'LifeSurge_74': '74',
  'LifeSurge_87F': '87F',
  'LifeSurge_CBB': 'CBB',
  'Liftoff_1119': '1119',
  'Liftoff_CBE': 'CBE',
  'LightBeyondDarkness_789': '789',
  'LightBeyondDarkness_970': '970',
  'LightDamageUp': '11DC',
  'LightInTheDark_636': '636',
  'LightInTheDark_770': '770',
  'LightInTheDark_894': '894',
  'LightMedal_5DF': '5DF',
  'LightMedal_5E0': '5E0',
  'LightMedal_5E1': '5E1',
  'LightMedal_5E2': '5E2',
  'LightOfAscalon': '3AF',
  'LightResistanceDownIi': '1044',
  'LightResistanceDown_8E6': '8E6',
  'LightResistanceDown_C3F': 'C3F',
  'LightVengeance': '11D0',
  'LightVision': '14DF',
  'Lightheaded_8CA': '8CA',
  'Lightheaded_9C5': '9C5',
  'LightningAspected': 'B03',
  'LightningChain': '435',
  'LightningCharge': '146',
  'LightningConvergence': '4FD',
  'LightningLoaded': 'E2C',
  'LightningResistanceDownIi_1168': '1168',
  'LightningResistanceDownIi_402': '402',
  'LightningResistanceDownIi_4EC': '4EC',
  'LightningResistanceDownIi_7B5': '7B5',
  'LightningResistanceDownIi_82F': '82F',
  'LightningResistanceDownIi_861': '861',
  'LightningResistanceDownIi_BB6': 'BB6',
  'LightningResistanceDown_1122': '1122',
  'LightningResistanceDown_240': '240',
  'LightningResistanceDown_382': '382',
  'LightningResistanceDown_943': '943',
  'LightningResistanceUp': '20B',
  'LightningRod': 'A0E',
  'LightningShot': '958',
  'LightsAccord': 'DE1',
  'LightsDesign': '1040',
  'LightsDiscord': 'DE3',
  'Lightspeed_349': '349',
  'Lightspeed_57B': '57B',
  'Lightsteeped': '8D1',
  'LimitBreaker': 'B39',
  'Limp': '572',
  'LindwurmsPortent': '129D',
  'LingeringEchoes': 'CDC',
  'LiturgyOfTheBell': 'A95',
  'LiveBrazier': 'E17',
  'LiveCandle': 'E18',
  'LiveOffTheLand': '162',
  'LiveWire': '657',
  'LivingDead': '32A',
  'LlymlaensWard': 'E6',
  'LoadBearing_1420': '1420',
  'LoadBearing_4C0': '4C0',
  'LocalCodeSmell_D70': 'D70',
  'LocalCodeSmell_DAF': 'DAF',
  'LocalRegression_688': '688',
  'LocalRegression_DC9': 'DC9',
  'LocalResonance': '67E',
  'LogosMinded': '652',
  'LohsDaih': '59D',
  'LongFuse': '115F',
  'LoomingCrescendo': '6A3',
  'Looper_658': '658',
  'Looper_6A8': '6A8',
  'Looper_D80': 'D80',
  'LordOfCrownsDrawn': '806',
  'LordOfCrowns_10E9': '10E9',
  'LordOfCrowns_5AB': '5AB',
  'LordOfCrowns_754': '754',
  'LordUnshadowed': '10FF',
  'LostAethershield': '98B',
  'LostBanish': '924',
  'LostBloodRage': 'A06',
  'LostBravery': '925',
  'LostBubble': 'A03',
  'LostBurst': '9FE',
  'LostChainspell': 'A00',
  'LostDervish': '98C',
  'LostExcellence': 'A04',
  'LostFlareStar': '988',
  'LostFontOfMagic': '91C',
  'LostFontOfPower': '92A',
  'LostIncense': '934',
  'LostManawall': '929',
  'LostProtect': '91D',
  'LostProtectIi': 'A01',
  'LostRampage': '9FF',
  'LostReflect': '921',
  'LostRendArmor': '989',
  'LostShell': '91E',
  'LostShellIi': 'A02',
  'LostSpellforge': '922',
  'LostStealth': '920',
  'LostSteelsting': '923',
  'LostSwift': '91F',
  'LovelyPoison': 'F4B',
  'LovesTrueForm': '65E',
  'LowArithmeticks': '3FD',
  'LucidDreaming': '4B4',
  'LuckyCarrot': 'AF7',
  'LuminiferousAether': '34A',
  'LuminousAetheroplasm': '2C2',
  'LunarDefensive': '9FA',
  'LuwatenaPulse': 'EC9',
  'Lype': 'C30',
  'Macrocosmos_A9E': 'A9E',
  'Macrocosmos_C20': 'C20',
  'Macrocosmos_F95': 'F95',
  'MadeenPortrait': '1008',
  'MagesBallad_87': '87',
  'MagesBallad_88': '88',
  'MagesBallad_8A9': '8A9',
  'MagicBurst': '674',
  'MagicDamageDown_3A': '3A',
  'MagicDamageDown_79C': '79C',
  'MagicDamageUp_39': '39',
  'MagicDamageUp_3FB': '3FB',
  'MagicDamageUp_484': '484',
  'MagicDamageUp_9FC': '9FC',
  'MagicDamageUp_AF9': 'AF9',
  'MagicDamageUp_E7B': 'E7B',
  'MagicDefenseDown': '26',
  'MagicDefenseUp': '25',
  'MagicInfusion': '6FF',
  'MagicNumber': 'DCC',
  'MagicResistance_3AE': '3AE',
  'MagicResistance_E25': 'E25',
  'MagicShell': '12B4',
  'MagicVulnerabilityDown_14B': '14B',
  'MagicVulnerabilityDown_246': '246',
  'MagicVulnerabilityDown_258': '258',
  'MagicVulnerabilityDown_32C': '32C',
  'MagicVulnerabilityDown_3B': '3B',
  'MagicVulnerabilityDown_E37': 'E37',
  'MagicVulnerabilityUp_1EE': '1EE',
  'MagicVulnerabilityUp_292': '292',
  'MagicVulnerabilityUp_3C': '3C',
  'MagicVulnerabilityUp_472': '472',
  'MagicVulnerabilityUp_82B': '82B',
  'MagicVulnerabilityUp_B7D': 'B7D',
  'MagicVulnerabilityUp_D56': 'D56',
  'MagicVulnerabilityUp_DBC': 'DBC',
  'MagicVulnerabilityUp_DD0': 'DD0',
  'MagicalAversion': '942',
  'MagickBarrier_A93': 'A93',
  'MagickBarrier_CA8': 'CA8',
  'MagickedSwordplay': 'F23',
  'MagitekField_5A4': '5A4',
  'MagitekField_876': '876',
  'MagitekLevitation': '551',
  'MagneticLevitation_12E5': '12E5',
  'MagneticLevitation_414': '414',
  'MagneticLevitation_610': '610',
  'MagneticLysis_60E': '60E',
  'MagneticLysis_60F': '60F',
  'MagneticPull': '12E6',
  'MagossMantle': 'B3D',
  'Maim': '55',
  'MainHullOperational': '469',
  'MainHullReassembly': '466',
  'MakersMark': '36E',
  'MakeshiftBait': 'ADB',
  'Malady': 'BF',
  'MaleficEW': '12A7',
  'MaleficE_12A5': '12A5',
  'MaleficE_1366': '1366',
  'MaleficN': '12AC',
  'MaleficNE': '12AD',
  'MaleficNEW': '12AF',
  'MaleficNS': '12B0',
  'MaleficNSE': '12B1',
  'MaleficNSEW': '12B3',
  'MaleficNSW': '12B2',
  'MaleficNW': '12AE',
  'MaleficS': '12A8',
  'MaleficSE': '12A9',
  'MaleficSEW': '12AB',
  'MaleficSW': '12AA',
  'MaleficW_12A6': '12A6',
  'MaleficW_1367': '1367',
  'Malodorous': '6B3',
  'ManaCapacitor': '2B1',
  'ManaCharge': '5CA',
  'ManaHypersensitivity': '59A',
  'ManaMedication': 'F78',
  'ManaModulation': '11A',
  'Manafication': '7B3',
  'Manawall': 'A9',
  'Manaward_7C5': '7C5',
  'Manaward_A8': 'A8',
  'MandervilleSprint_D92': 'D92',
  'MandervilleSprint_DBB': 'DBB',
  'Manipulation_102': '102',
  'Manipulation_48C': '48C',
  'MantleOfTheWhorl': '1DD',
  'Mantra': '66',
  'ManusyaBerserk': 'A5B',
  'ManusyaConfuse': 'A5C',
  'ManusyaStop': 'A5D',
  'MarchingOrders': '936',
  'MarchingOrdersAFamiliarFace': 'A19',
  'MarchingOrdersFeelingTheBurn': 'A14',
  'MarchingOrdersHereComesTheCavalry': 'A17',
  'MarchingOrdersKillItWithFire': '938',
  'MarchingOrdersMetalFoxChaos': '93C',
  'MarchingOrdersNeverCryWolf': 'A16',
  'MarchingOrdersOnSerpentsWings': 'A15',
  'MarchingOrdersRiseOfTheRobots': '93B',
  'MarchingOrdersTheFinalFurlong': '93A',
  'MarchingOrdersTheHuntForRedChoctober': '939',
  'MarchingOrdersVigilForTheLost': '937',
  'MarchingOrdersWornToAShadow': 'A18',
  'MarkOfEasyPrey': 'ACF',
  'MarkOfMortality_1114': '1114',
  'MarkOfMortality_701': '701',
  'MarkOfMortality_945': '945',
  'MarkOfTheDepths': 'AD1',
  'MarkOfTheHarvest': 'DA0',
  'MarkOfTheTides': 'AD0',
  'MarkUp': '19D',
  'MarkedForCulling': '3E2',
  'MarkedForDamageDown': '2B4',
  'MarkedForHealingMagicDown': '2B5',
  'MarkedForVulnerabilityUp': '2B3',
  'MaterialMiracle': '107C',
  'MawMotif': '100C',
  'MawSketch': '101F',
  'MeatAndMead': '168',
  'MeatShield_845': '845',
  'MeatShield_8DB': '8DB',
  'MeatilyShielded': '844',
  'MedicaIi': '96',
  'MedicaIiOfTheSeventhDawn': 'CE4',
  'MedicaIiiOfTheSeventhDawn': 'F93',
  'MedicaIii_F28': 'F28',
  'MedicaIii_F92': 'F92',
  'Medicated': '31',
  'Meditate': '4CF',
  'Meditation_749': '749',
  'Meditation_880': '880',
  'MeditativeBrotherhood_49E': '49E',
  'MeditativeBrotherhood_87D': '87D',
  'MeikyoShisui_4D1': '4D1',
  'MeikyoShisui_528': '528',
  'Meisui_A81': 'A81',
  'Meisui_C75': 'C75',
  'Memorable': 'A05',
  'MemoryDegradation': '659',
  'MemoryLoss': '65A',
  'MenphinasWard': 'E4',
  'MercifulAir': '9B9',
  'Mesmerized': '12C2',
  'Mesotes_C2E': 'C2E',
  'Mesotes_C2F': 'C2F',
  'Meteodrive': 'C66',
  'Miasma': 'B4',
  'MiasmaIi': 'BC',
  'MiasmaIii_4BF': '4BF',
  'MiasmaIii_52F': '52F',
  'MidGlitch': 'D63',
  'MidsummerNightsBalm': '11E8',
  'MightOfCrags': 'BC2',
  'MightOfTheInferno': 'BC3',
  'MightOfTheVortex': 'BC1',
  'MightyGuard': '6B7',
  'MightyMarch': '1096',
  'MightyStrikes_1066': '1066',
  'MightyStrikes_1202': '1202',
  'Mimic': '420',
  'Mimicry': '992',
  'Mini': 'DBE',
  'Minimum_1B6': '1B6',
  'Minimum_1B8': '1B8',
  'Minimum_9C8': '9C8',
  'MiracleOfNature': 'C0D',
  'MirroredIncantation': 'B20',
  'MirroredSmoke': 'DC0',
  'Miscast': 'AF3',
  'Misery': '1AE',
  'MissingLink': 'E03',
  'MistyMirage': '109E',
  'MistyVeil': '1A3',
  'MitoticPhase': '129C',
  'ModestLure': 'F85',
  'Modification': '149',
  'MogdarkResistanceDown': '1D8',
  'MoglightResistanceDown': '1D7',
  'MonochromeTones': 'E6B',
  'Monomachy_4D9': '4D9',
  'Monomachy_4DA': '4DA',
  'Monomachy_CAA': 'CAA',
  'MonsterResistance_3CB': '3CB',
  'MonsterResistance_3D7': '3D7',
  'MonsterVulnerability': '3CF',
  'Monstrous': '726',
  'MooglePortrait': '1007',
  'Moonlit': '602',
  'Moonseal': '470',
  'Moonshadowed': '603',
  'MoonsporeSpurred': 'DB8',
  'MorbidMeal': '1272',
  'MoreThanSatisfied': '1278',
  'MortalAtonement': 'B51',
  'MortalFlame_858': '858',
  'MortalFlame_E3B': 'E3B',
  'MortalPowderMark_89B': '89B',
  'MortalPowderMark_9B7': '9B7',
  'MortalPowderMark_9DF': '9DF',
  'MortalVow': 'B50',
  'Mortared': 'C55',
  'Mortific': '11EC',
  'MotionTracker': '1447',
  'MountainBuster': '159B',
  'Mounted_58C': '58C',
  'Mounted_5F0': '5F0',
  'MousasMantle': 'B3E',
  'MousseMine': '1165',
  'MovementEdict2Squares_9AA': '9AA',
  'MovementEdict2Squares_9AD': '9AD',
  'MovementEdict3Squares_9AB': '9AB',
  'MovementEdict3Squares_9AE': '9AE',
  'MovementEdict4Squares_9AC': '9AC',
  'MovementEdict4Squares_9AF': '9AF',
  'MovementSpeedUp_29D': '29D',
  'MovementSpeedUp_458': '458',
  'MovementSpeedUp_ECF': 'ECF',
  'MpBoost': '17',
  'MpPenalty': '18',
  'Muddy': '646',
  'Mudra': '1F0',
  'Mug': 'C6F',
  'Multihook': '113E',
  'Multisplice': 'D12',
  'Mummification_25B': '25B',
  'Mummification_C13': 'C13',
  'MuscleActivator': '2B2',
  'MuscleMemory': '88F',
  'MustardBomb': 'FA7',
  'MustardBombproof': 'FA8',
  'MutatingCells': '12A2',
  'Mutation_12A1': '12A1',
  'Mutation_12A3': '12A3',
  'Mutation_62E': '62E',
  'Mutation_634': '634',
  'Mutation_635': '635',
  'Mutation_63E': '63E',
  'Mutation_6A2': '6A2',
  'Mutation_6A4': '6A4',
  'Mutilation': '1EC',
  'NaldthalsWard': 'E5',
  'NameOfTheElements_367': '367',
  'NameOfTheElements_77C': '77C',
  'Nameless': '36D',
  'Nanoparticles': '2A1',
  'NascentChaos': '769',
  'NascentFlash_741': '741',
  'NascentFlash_80D': '80D',
  'NascentFlash_8B3': '8B3',
  'NascentGlint_742': '742',
  'NascentGlint_80E': '80E',
  'NastrondReady_1134': '1134',
  'NastrondReady_F04': 'F04',
  'NastySurprise': '9F5',
  'NaturalAlignment': 'D54',
  'NaturesBounty': '493',
  'NaturesMinne': '4B2',
  'Nausea': '954',
  'NeapTide': 'D01',
  'NearShoreShackles': '1274',
  'NearbyPortent': '129F',
  'Nebula_72A': '72A',
  'Nebula_BEB': 'BEB',
  'Necrosis': 'B95',
  'Nectar': '39F',
  'NeedlePoised': '116B',
  'NeedleVeil': 'EA7',
  'NegativeCharge_11C8': '11C8',
  'NegativeCharge_12D6': '12D6',
  'NegativeCharge_12D8': '12D8',
  'NegativeCharge_2BB': '2BB',
  'NegativeCharge_D59': 'D59',
  'NegativeCharge_D5B': 'D5B',
  'NegativeCharge_FE8': 'FE8',
  'Negatron': 'FA1',
  'NereidicGravity': '1157',
  'Neurolink_158': '158',
  'Neurolink_273': '273',
  'Neurolink_B12': 'B12',
  'NeutralSect_764': '764',
  'NeutralSect_781': '781',
  'NeutralSect_7FC': '7FC',
  'NeutralSect_F94': 'F94',
  'NewMoon': '600',
  'Nightmare': '1A7',
  'NineLives': 'F5B',
  'NoMercy_727': '727',
  'NoMercy_BE2': 'BE2',
  'Noctoshield': '1AA',
  'NocturnalBalance': '7FB',
  'NocturnalBenefic': 'C1C',
  'NocturnalField_345': '345',
  'NocturnalField_887': '887',
  'NocturnalOpposition_758': '758',
  'NocturnalOpposition_817': '817',
  'NocturnalSect': '348',
  'NohurtsGoblixer': '3F0',
  'NophicasWard': 'E0',
  'Normal': '89C',
  'NormalStance': '1CB',
  'NoseForBattle': '486',
  'NovaOoze': '1159',
  'NowBoarding': '11A1',
  'NowhereToRun': '11A7',
  'NoxiousGnash_1003': '1003',
  'NoxiousGnash_E53': 'E53',
  'Nuisance': 'F6E',
  'NullBlack': 'A4B',
  'NullWhite': 'A4A',
  'NumbingCurrent': 'F8C',
  'NymianPlague': '311',
  'OasalBalm_EA8': 'EA8',
  'OasalBalm_EA9': 'EA9',
  'Obfuscated_450': '450',
  'Obfuscated_452': '452',
  'Oblatio': 'F11',
  'Oblation': 'A7A',
  'OccultMageMasher': '10A3',
  'OccultQuick': '10A4',
  'OccultSprint': '10B4',
  'OccultSwift': '10A5',
  'OccultUnicorn': '1093',
  'Odder': '60A',
  'OdderIncarnation_E11': 'E11',
  'OdderIncarnation_E12': 'E12',
  'OdderIncarnation_E13': 'E13',
  'OdderIncarnation_E14': 'E14',
  'OdderPrayer': 'E16',
  'OffBalance_428': '428',
  'OffBalance_569': '569',
  'OffGuard': '6B5',
  'OffenseKit': '3E0',
  'OffensiveAria': '1097',
  'OffensiveOptimization': '2A9',
  'OffensiveTactics': '5A0',
  'OgiNamikiri': 'C7F',
  'OgiNamikiriReady': 'B8F',
  'Oil': '86D',
  'Old': '4EB',
  'OmegaF': '68B',
  'OmegaM_68A': '68A',
  'OmegaM_D7E': 'D7E',
  'Omega_67A': '67A',
  'Omega_D79': 'D79',
  'OminousWind': '5C9',
  'OnARoll': 'F9C',
  'OnBalance': 'BC7',
  'OnFire': '9F3',
  'OneMind': '9F9',
  'OneTwoMemory': 'FD0',
  'Onslaught': 'BD5',
  'OpoOpoForm': '6B',
  'Opposition': '757',
  'Orogeny': 'CB8',
  'OutOfBody': '30B',
  'OutOfControl_965': '965',
  'OutOfControl_CF4': 'CF4',
  'OutOfControl_D22': 'D22',
  'OutOfTheAction_272': '272',
  'OutOfTheAction_3AB': '3AB',
  'OutOfTheAction_459': '459',
  'OutOfTheAction_504': '504',
  'OutOfTheAction_5B6': '5B6',
  'OutOfTheAction_83D': '83D',
  'OuterDarkness': '1052',
  'Outsider': '12DF',
  'Overcure': '9C',
  'OverflowCodeSmell': 'D6D',
  'OverflowDebugger_684': '684',
  'OverflowDebugger_D67': 'D67',
  'Overheated_A80': 'A80',
  'Overheated_C4D': 'C4D',
  'Overload': 'CF0',
  'Overmedicated': 'F7A',
  'OversampledWaveCannonLoading_D7C': 'D7C',
  'OversampledWaveCannonLoading_D7D': 'D7D',
  'Owlet': 'DAE',
  'Pacification_26C': '26C',
  'Pacification_6': '6',
  'Pacification_D5': 'D5',
  'PacketFilterF_67D': '67D',
  'PacketFilterF_DAC': 'DAC',
  'PacketFilterM_67C': '67C',
  'PacketFilterM_DAB': 'DAB',
  'Pain': '955',
  'Palisade': '4AC',
  'PallOfDarkness': '93F',
  'PallOfGrief': '8A3',
  'PallOfRage': '8A2',
  'Panhaima': 'A35',
  'Panhaimatinon': 'A53',
  'Panic': '8DF',
  'ParadiseFound': '11E5',
  'ParadiseRegained': '7B6',
  'Paradox': 'C97',
  'Paralysis_11': '11',
  'Paralysis_1E2': '1E2',
  'Paralysis_3DC': '3DC',
  'Paralysis_D8': 'D8',
  'Paralysis_D87': 'D87',
  'Paralysis_F7B': 'F7B',
  'Partygoer': 'B01',
  'PassageOfArms': '497',
  'Passenger': '45E',
  'PatienceOfStone': '112B',
  'PatienceOfWind': '112A',
  'PayingThePiper': '691',
  'PeculiarLight': '6B9',
  'Peloton_4AF': '4AF',
  'Peloton_7C1': '7C1',
  'Penance_D93': 'D93',
  'Penance_D95': 'D95',
  'PenitentsShackles': 'D94',
  'PentUpRage': '108C',
  'PerfectBalance': '6E',
  'PerfectDeception': '772',
  'PerfectDefense_1500': '1500',
  'PerfectDefense_1501': '1501',
  'PerfectGroove': '1170',
  'PerfectioOcculta': 'F13',
  'PerfectioParata_10D5': '10D5',
  'PerfectioParata_F14': 'F14',
  'PerfectionAlpha': 'D05',
  'PerfectionBeta': 'D06',
  'PerfectionGamma': 'D07',
  'PerformanceCodeSmell': 'D6F',
  'PerformanceDebugger': 'D69',
  'PerpetualConflagration': '101A',
  'PetrificationResistance': '1C2',
  'Petrification_1': '1',
  'Petrification_115D': '115D',
  'Petrification_262': '262',
  'Petrification_5E7': '5E7',
  'Petrification_BBF': 'BBF',
  'Phalanx': 'C8A',
  'Phantasmal': '76F',
  'PhantomAim': '1090',
  'PhantomBard': '110B',
  'PhantomBerserker': '1107',
  'PhantomCannoneer': '110E',
  'PhantomChemist': '110F',
  'PhantomDancer': '12C5',
  'PhantomDart': '7C2',
  'PhantomDoom': '10B1',
  'PhantomEdge': '9B8',
  'PhantomFlurry': '9C6',
  'PhantomFreelancer': '1092',
  'PhantomGeomancer': '110C',
  'PhantomGladiator': '12C4',
  'PhantomGuard': '1087',
  'PhantomKamaitachiReady': 'AA3',
  'PhantomKick': '108D',
  'PhantomKnight': '1106',
  'PhantomMastery': '1082',
  'PhantomMonk': '1108',
  'PhantomMysticKnight': '12C3',
  'PhantomOracle': '1110',
  'PhantomRanger': '1109',
  'PhantomRejuvenation': '10B2',
  'PhantomSamurai': '110A',
  'PhantomThief': '1111',
  'PhantomTimeMage': '110D',
  'PhilosophersCarrot': 'AF6',
  'Philosophia': 'F3A',
  'Phlebotomize': '77',
  'PhobosicGravity': '1158',
  'PhoenixsBlessing': '59C',
  'PhysicalAttenuation': '84B',
  'PhysicalAversion': '941',
  'PhysicalDamageDown_119': '119',
  'PhysicalDamageDown_18B': '18B',
  'PhysicalDamageDown_36': '36',
  'PhysicalDamageUp_35': '35',
  'PhysicalDamageUp_3F9': '3F9',
  'PhysicalDamageUp_3FA': '3FA',
  'PhysicalDamageUp_473': '473',
  'PhysicalDamageUp_81A': '81A',
  'PhysicalDamageUp_9FB': '9FB',
  'PhysicalField': '154',
  'PhysicalVulnerabilityDown_247': '247',
  'PhysicalVulnerabilityDown_259': '259',
  'PhysicalVulnerabilityDown_37': '37',
  'PhysicalVulnerabilityDown_383': '383',
  'PhysicalVulnerabilityDown_E36': 'E36',
  'PhysicalVulnerabilityUp_1042': '1042',
  'PhysicalVulnerabilityUp_1ED': '1ED',
  'PhysicalVulnerabilityUp_291': '291',
  'PhysicalVulnerabilityUp_2B7': '2B7',
  'PhysicalVulnerabilityUp_38': '38',
  'PhysicalVulnerabilityUp_3A6': '3A6',
  'PhysicalVulnerabilityUp_7E': '7E',
  'PhysicalVulnerabilityUp_82A': '82A',
  'PhysicalVulnerabilityUp_B7C': 'B7C',
  'PhysicalVulnerabilityUp_C8': 'C8',
  'PhysicalVulnerabilityUp_D57': 'D57',
  'Physis': 'A39',
  'PhysisIi': 'A3C',
  'PickClean': '709',
  'PiercingResistanceDownIi': '59B',
  'PiercingResistanceDown_11BC': '11BC',
  'PiercingResistanceDown_334': '334',
  'PiercingResistanceDown_69E': '69E',
  'PiercingResistanceDown_C3B': 'C3B',
  'PiercingResistanceUp': '2D1',
  'Piggy': '50C',
  'Plagued': 'B4D',
  'PlanarImprisonment': 'A66',
  'PlasmaThrottleCharged': '1204',
  'PlayingWithFire': '1073',
  'PlayingWithIce': '1074',
  'Pledge': '108A',
  'PlentifulHarvest': 'C85',
  'Ploutonos': 'AE3',
  'Pneuma_A3F': 'A3F',
  'Pneuma_B34': 'B34',
  'PoisedForTwinblood': 'E52',
  'PoisedForTwinfang': 'E51',
  'PoisedToSwordDance': '12BA',
  'Poison1': '113',
  'PoisonL': '672',
  'PoisonNPop': 'F5E',
  'PoisonResistanceDownIi': 'F5F',
  'PoisonResistanceUp': '280',
  'Poison_12': '12',
  'Poison_22F': '22F',
  'Poison_230': '230',
  'Poison_2AE': '2AE',
  'Poison_321': '321',
  'Poison_829': '829',
  'Poison_838': '838',
  'Poison_B40': 'B40',
  'Poison_D3E': 'D3E',
  'Poison_D47': 'D47',
  'Poison_D86': 'D86',
  'Polarizing': 'DE7',
  'Pollen_13': '13',
  'Pollen_5E3': '5E3',
  'Polyglot': 'C61',
  'PomMotif': '1009',
  'PomMuse': '100D',
  'PomSketch': '101C',
  'Pombination': '1D6',
  'PoppetResistance_3CC': '3CC',
  'PoppetResistance_3D8': '3D8',
  'PoppetVulnerability': '3D0',
  'PositiveCharge_11C7': '11C7',
  'PositiveCharge_12D5': '12D5',
  'PositiveCharge_12D7': '12D7',
  'PositiveCharge_2BA': '2BA',
  'PositiveCharge_D58': 'D58',
  'PositiveCharge_D5A': 'D5A',
  'PositiveCharge_FE7': 'FE7',
  'Positron': 'FA0',
  'PotentAcid': '1BF',
  'PowderBarrel': 'BE3',
  'PowderMark': '993',
  'PowderMarkTrail': '1046',
  'PowerSaverMode': '1192',
  'PowerSlash': '55C',
  'PowerSurge_78': '78',
  'PowerSurge_AA0': 'AA0',
  'Powerful': 'D28',
  'Pox': '15B',
  'Pray': '1088',
  'PrayerOfLight': 'BC5',
  'PrayersOfHope': 'B0C',
  'Precision': 'E7E',
  'PredictionOfBlessing': '10AB',
  'PredictionOfCleansing': '10AA',
  'PredictionOfJudgment': '10A9',
  'PredictionOfStarfall': '10AC',
  'PreferredWorldBonus': '583',
  'PrefulgenceReady_10E2': '10E2',
  'PrefulgenceReady_F26': 'F26',
  'Preoccupied': '653',
  'Preparation': 'E8',
  'PresenceOfMind': '9D',
  'PressurePoint': 'C64',
  'PreyGreaterAxebit': '10F1',
  'PreyLancepoint': '10F2',
  'PreyLesserAxebit': '10F0',
  'Prey_1179': '1179',
  'Prey_1A4': '1A4',
  'Prey_232': '232',
  'Prey_298': '298',
  'Prey_388': '388',
  'Prey_3BE': '3BE',
  'Prey_41B': '41B',
  'Prey_4E5': '4E5',
  'Prey_83F': '83F',
  'Prey_840': '840',
  'Prey_A55': 'A55',
  'Prey_B7B': 'B7B',
  'Prey_E82': 'E82',
  'PrideOfTheLioness': '9A3',
  'PrimalRage': '61F',
  'PrimalRendReady': 'A40',
  'PrimalRuinationReady_10BD': '10BD',
  'PrimalRuinationReady_EFA': 'EFA',
  'PrimaryTarget': '699',
  'PrimevalImpulse': 'F3C',
  'PrimingTouch': 'F46',
  'PrimordialCrust': '645',
  'PriorityAetherytePass': '425',
  'PrioritySealAllowance': '436',
  'PrizeCatch': 'ADC',
  'ProcessOfEliminationA': '969',
  'ProcessOfEliminationB': '96A',
  'ProcessOfEliminationC': '96B',
  'Program000000': 'A49',
  'ProgramFffffff': 'A48',
  'Projection': 'FCF',
  'ProjectionLocus': '11E4',
  'Promotion': '354',
  'ProperCare': '16A',
  'Prospect': 'E1',
  'ProtectL': '66A',
  'Protect_1A1': '1A1',
  'Protect_587': '587',
  'Protect_805': '805',
  'Protect_92': '92',
  'Protect_93': '93',
  'Protraction': 'A96',
  'ProximateCurrent': 'FA3',
  'Pumpkin': '451',
  'Pure': '11ED',
  'PureMuscle': '6FA',
  'PurgatoryWinds_CEE': 'CEE',
  'PurgatoryWinds_D3F': 'D3F',
  'PurgatoryWinds_D40': 'D40',
  'PurgatoryWinds_D41': 'D41',
  'PushBack': '366',
  'Pvp': '118D',
  'PvpRoleActionBloodbath': '1186',
  'PvpRoleActionBravery': '118A',
  'PvpRoleActionComet': '118C',
  'PvpRoleActionDervish': '1189',
  'PvpRoleActionDiabrosis': '1191',
  'PvpRoleActionEagleEyeShot': '118B',
  'PvpRoleActionFullSwing': '1185',
  'PvpRoleActionHaelan': '118F',
  'PvpRoleActionPhantomDart': '11A4',
  'PvpRoleActionRampage': '1183',
  'PvpRoleActionRampart': '1184',
  'PvpRoleActionRust': '118E',
  'PvpRoleActionSmite': '1188',
  'PvpRoleActionStoneskinIi': '1190',
  'PvpRoleActionSwift': '1187',
  'Pyramid': '42F',
  'Pyrefaction': 'E06',
  'PyreticBooster': '8F6',
  'Pyretic_27F': '27F',
  'Pyretic_3C0': '3C0',
  'Pyretic_419': '419',
  'Pyretic_46D': '46D',
  'Pyretic_63F': '63F',
  'Pyretic_DC2': 'DC2',
  'Pyromania': '1075',
  'Quadruple': 'AAC',
  'QuantumEntanglement': '1314',
  'QuantumNullification': '1313',
  'Quarantine': '3A4',
  'QuarteredSoul': 'DFF',
  'QueenBee': 'F60',
  'QuickSketch': '10E4',
  'QuickeningDynamis': 'D74',
  'QuickerNock': '84',
  'QuickerStep': '12BF',
  'Quickstep': '12BE',
  'Quintuplecast': '948',
  'RadiantAegis_A8E': 'A8E',
  'RadiantAegis_C98': 'C98',
  'RadiantEncoreReady': 'F17',
  'RadiantFinale_AA2': 'AA2',
  'RadiantFinale_B94': 'B94',
  'RadiantShield': '139',
  'RadiantVeil': 'DDA',
  'Rage': '108B',
  'RageOfHalone': '55A',
  'RagingRroneek': 'EAE',
  'RagingStrikes': '7D',
  'RaijuReady': 'A82',
  'RainOfDeath': 'F7',
  'RainbowBright': 'E5F',
  'Raise_474': '474',
  'Raise_94': '94',
  'Rampage': '117C',
  'Rampart_1048': '1048',
  'Rampart_47': '47',
  'Rampart_4A7': '4A7',
  'Rampart_7BA': '7BA',
  'Rancor': '15F',
  'RangedResistance': '3AD',
  'Ranging': '796',
  'RapidFire': '355',
  'RapidRecast': '66D',
  'RapidRecitation': '11EE',
  'RaptorForm': '6C',
  'RatAndMouse': 'E19',
  'Rationing': '43C',
  'RavenBlight': '1CA',
  'RawIntuition': '2DF',
  'RayOfFortitude': 'A41',
  'RayOfSuccor': 'A43',
  'RayOfValor': 'A42',
  'RazedEarth': '138',
  'ReadyToBlast_A7E': 'A7E',
  'ReadyToBlast_BE1': 'BE1',
  'ReadyToBreak': 'F2E',
  'ReadyToGouge_734': '734',
  'ReadyToGouge_7D4': '7D4',
  'ReadyToRaze_10C5': '10C5',
  'ReadyToRaze_EFF': 'EFF',
  'ReadyToReawaken': 'E57',
  'ReadyToReign': 'F00',
  'ReadyToRip_732': '732',
  'ReadyToRip_7D2': '7D2',
  'ReadyToTear_733': '733',
  'ReadyToTear_7D3': '7D3',
  'RearBlasterCharge': 'D8D',
  'RearMarkOfTheTides': 'AD3',
  'RearwardOmen_103A': '103A',
  'RearwardOmen_1142': '1142',
  'RearwardOmen_1146': '1146',
  'RearwardOmen_114B': '114B',
  'Reassembled': '353',
  'Reawakened_E56': 'E56',
  'Reawakened_FFE': 'FFE',
  'Recharge': '159',
  'Recitation_768': '768',
  'Recitation_C16': 'C16',
  'Reclaim': '104',
  'Recuperation_10AF': '10AF',
  'Recuperation_112': '112',
  'Recuperation_4CE': '4CE',
  'RedLight_297': '297',
  'RedLight_86F': '86F',
  'RedPaint': '5BE',
  'RedrawnDomain': '1105',
  'ReducedImmunity': '143',
  'ReducedRates': '16C',
  'Reflect': '206',
  'ReflectL': '671',
  'Reforged_6EF': '6EF',
  'Reforged_6F1': '6F1',
  'RefreshL': '673',
  'Refresh_38D': '38D',
  'Refresh_4AE': '4AE',
  'RefulgentChain_8CD': '8CD',
  'RefulgentChain_8CE': '8CE',
  'RefulgentFate_8CF': '8CF',
  'RefulgentFate_8D0': '8D0',
  'RefulgentLux': 'F22',
  'Regain': '19F',
  'Regen_381': '381',
  'Regen_532': '532',
  'Regen_9E': '9E',
  'Rehabilitation_105F': '105F',
  'Rehabilitation_117': '117',
  'Rehabilitation_1DF': '1DF',
  'Rehabilitation_288': '288',
  'Rehabilitation_3DD': '3DD',
  'Rehabilitation_3F6': '3F6',
  'Rehabilitation_4EF': '4EF',
  'Rehabilitation_697': '697',
  'Rehabilitation_D27': 'D27',
  'Rehabilitation_DA4': 'DA4',
  'Rekindle': 'A90',
  'RelentlessMarch_116': '116',
  'RelentlessMarch_135': '135',
  'RelentlessRush': 'BEC',
  'RelentlessShrapnel': 'BED',
  'Reminiscence': '92C',
  'RemoteCodeSmell_D71': 'D71',
  'RemoteCodeSmell_DB0': 'DB0',
  'RemoteCurrent': 'FA2',
  'RemoteGlitch': 'D64',
  'RemoteRegression_689': '689',
  'RemoteRegression_DCA': 'DCA',
  'RemoteResonance': '67F',
  'RentMind': '35B',
  'RepellingShot': '7E1',
  'RepellingSpray_156': '156',
  'RepellingSpray_22B': '22B',
  'RepellingSpray_22C': '22C',
  'RepellingSpray_22D': '22D',
  'RepellingSpray_22E': '22E',
  'Repertoire': 'C41',
  'Reprisal_2F1': '2F1',
  'Reprisal_4A9': '4A9',
  'Reprisal_835': '835',
  'Requiescat_558': '558',
  'Requiescat_559': '559',
  'RequisitionedMagitek': 'AB0',
  'Reraise': '933',
  'Resilience': 'CB0',
  'Resin': '2A2',
  'ResonantArrowReady': 'F16',
  'Resonant_30C': '30C',
  'Resonant_59E': '59E',
  'RestrainingOrder': '464',
  'RestrictedAccess': '9DB',
  'ResurrectionDenied': '10A7',
  'ResurrectionRestricted_10A6': '10A6',
  'ResurrectionRestricted_6DB': '6DB',
  'ResurrectionRestricted_991': '991',
  'ResurrectionRestricted_D34': 'D34',
  'Retaliation': '888',
  'RetrogradeReady': '10EB',
  'Return': '994',
  'ReturnIi': '104C',
  'ReturnIv': '995',
  'Reusing': '70E',
  'Revelation': 'CA0',
  'RevelationResistanceDown': '24C',
  'ReversalOfForces': '98F',
  'Reverse': '3F5',
  'RevisedToBlizzards': 'FEA',
  'RevisedToGaleForceWinds': 'FEC',
  'RevisedToHyperelectricity': 'FEB',
  'RevisedToWildfires': 'FE9',
  'Revolutionary': 'B59',
  'RhythmeticFever': 'C08',
  'RiddleOfEarth_49B': '49B',
  'RiddleOfEarth_51E': '51E',
  'RiddleOfEarth_7D8': '7D8',
  'RiddleOfFire_49D': '49D',
  'RiddleOfFire_585': '585',
  'RiddleOfWind_4DC': '4DC',
  'RiddleOfWind_554': '554',
  'RiddleOfWind_A7F': 'A7F',
  'RightArmOperational': '46A',
  'RightArmPrimed': 'A0F',
  'RightArmReassembly': '467',
  'RightBlasterCharge': 'D8F',
  'RightEye_49F': '49F',
  'RightEye_5AD': '5AD',
  'RightEye_776': '776',
  'RightFace_144B': '144B',
  'RightFace_510': '510',
  'RightFace_7A9': '7A9',
  'RightFace_874': '874',
  'RightFace_950': '950',
  'RightFace_DD5': 'DD5',
  'RightFace_E75': 'E75',
  'RightFace_E86': 'E86',
  'RightMarkOfTheTides': 'AD5',
  'RightOfEntryTheForkedTower': '117A',
  'RightUnseen_6AB': '6AB',
  'RightUnseen_E90': 'E90',
  'RightWindup_FBE': 'FBE',
  'RightWindup_FC0': 'FC0',
  'RightWithThee': '8C3',
  'RightwardBearing': 'B16',
  'RightwardFracture': 'FC4',
  'RightwardMemory': 'FD2',
  'RightwardOmen_1038': '1038',
  'RightwardOmen_103C': '103C',
  'RightwardOmen_1144': '1144',
  'RightwardOmen_1149': '1149',
  'RightwardOmen_114D': '114D',
  'RightwardWhimsy': 'B18',
  'Riled_47A': '47A',
  'Riled_F4A': 'F4A',
  'RingOfFire': '250',
  'RingingRespite': '10A1',
  'RipeForReaping': 'B2A',
  'RiseOfThePhoenix': '251',
  'RisingRhythm': 'A88',
  'RiteOfPassage': 'CCD',
  'RiteOfTheGreatWhale': 'E97',
  'RiteOfTheSeaTurtle': 'E96',
  'RiteOfTheSparrow': 'E95',
  'RoadToToad': '3F1',
  'RoarOfConviction': 'F48',
  'RodentialRebirth_E0D': 'E0D',
  'RodentialRebirth_E0E': 'E0E',
  'RodentialRebirth_E0F': 'E0F',
  'RodentialRebirth_E10': 'E10',
  'RoleCall': 'AF2',
  'RolePlaying': '5FE',
  'RomeosBallad': '1094',
  'RottenHoney': '1031',
  'RottingFlesh': '129B',
  'RottingLungs': '26E',
  'RoundhouseConductor': 'FA5',
  'Rouse': 'BB',
  'RoyalFavor': '9DC',
  'RoyalGuard_188': '188',
  'RoyalGuard_729': '729',
  'RoyalRoad': '33B',
  'RoyalRouse': '1DA',
  'RroneekPulse_1049': '1049',
  'RroneekPulse_EC7': 'EC7',
  'RroneeksFavor': 'F70',
  'RubysGlimmer': 'F21',
  'Ruination': '50B',
  'RunningCold1': '8DC',
  'RunningCold2': '8E2',
  'RunningHot1': '89D',
  'RunningHot2': '8A4',
  'RunningWild': '8EC',
  'RushEdict': '695',
  'Rust': '1180',
  'SaberDance': '7E6',
  'SacredClaim': 'BD1',
  'SacredSight_10E6': '10E6',
  'SacredSight_F27': 'F27',
  'SacredSoil_12A': '12A',
  'SacredSoil_12B': '12B',
  'SacredSoil_798': '798',
  'SacredSoil_A4D': 'A4D',
  'SacredSoil_A4E': 'A4E',
  'Sacrifice': '6CF',
  'SacrificesFate': '97F',
  'Safeguard': '18D',
  'SafetyLockAetherialAegis': '904',
  'SafetyLockPyreticBooster': '903',
  'SagesWisdom': 'B99',
  'SaltedEarth_2ED': '2ED',
  'SaltedEarth_BDC': 'BDC',
  'SaltedEarth_BDD': 'BDD',
  'SaltsBane': 'BDE',
  'Salvage': '494',
  'Sanction': 'F5',
  'SaplingsCrown': '1273',
  'Satisfied': '1277',
  'ScaleFlakes': '1AD',
  'Scalebound': '5D7',
  'ScarletFlame': 'C9F',
  'ScatteredWailing': 'DEB',
  'Schiltron': 'E2F',
  'Scorch': '10DF',
  'Scorn_10C2': '10C2',
  'Scorn_EFD': 'EFD',
  'Scourge': '2E5',
  'ScouringWaters': '765',
  'ScreamOfTheFallen': 'CDB',
  'Scrutiny': '2F5',
  'SealSweetener': '19E',
  'SealedDoton': 'C7D',
  'SealedForkedRaiju': 'C7B',
  'SealedGokaMekkyaku': 'C79',
  'SealedHuton': 'C7C',
  'SealedHyoshoRanryu': 'C7A',
  'SealedMeisui': 'C7E',
  'SearingChains': '11D3',
  'SearingLight': 'A8F',
  'SearingWind_178': '178',
  'SearingWind_62A': '62A',
  'SeasonsOfTheFleeting': 'E27',
  'SecondBrand': 'CC5',
  'SecondChakra': '31A',
  'SecondFlame': 'CC9',
  'SecondInLine': 'BBD',
  'Seduced_337': '337',
  'Seduced_3DF': '3DF',
  'Seduced_56D': '56D',
  'Seduced_8DA': '8DA',
  'Seduced_BD0': 'BD0',
  'Seduced_D23': 'D23',
  'Seduced_E28': 'E28',
  'Seduced_E3': 'E3',
  'SeedCrystals': 'EE1',
  'SeedOfLife': '3F7',
  'Seized_191': '191',
  'Seized_261': '261',
  'Seized_3C1': '3C1',
  'Seized_507': '507',
  'Seized_E71': 'E71',
  'SenrisFavor': '632',
  'Sentinel': '4A',
  'SepulchreReady_10BA': '10BA',
  'SepulchreReady_EF4': 'EF4',
  'SequenceAb1': '150',
  'SequenceAp1': '151',
  'SequenceAs1': '152',
  'SeraphFlight': 'C18',
  'SeraphicIllumination_1132': '1132',
  'SeraphicIllumination_753': '753',
  'SeraphicVeil_77D': '77D',
  'SeraphicVeil_7F8': '7F8',
  'SeraphicVeil_C19': 'C19',
  'Seraphism_10E7': '10E7',
  'Seraphism_F2C': 'F2C',
  'Seraphism_F2D': 'F2D',
  'ServantOfShadow_973': '973',
  'ServantOfShadow_974': '974',
  'ServantOfShadow_975': '975',
  'ServantOfShadow_976': '976',
  'SeventhHeaven': 'E9D',
  'SevereDamage': '2C9',
  'ShackledAbilities': '11D5',
  'ShackledApart': '978',
  'ShackledHealing': '11D4',
  'ShackledTogether_979': '979',
  'ShackledTogether_E04': 'E04',
  'ShacklesOfCompanionship_AB6': 'AB6',
  'ShacklesOfCompanionship_B45': 'B45',
  'ShacklesOfCompanionship_B46': 'B46',
  'ShacklesOfCompanionship_B47': 'B47',
  'ShacklesOfCompanionship_B6B': 'B6B',
  'ShacklesOfLoneliness_AB7': 'AB7',
  'ShacklesOfLoneliness_B48': 'B48',
  'ShacklesOfLoneliness_B49': 'B49',
  'ShacklesOfLoneliness_B4A': 'B4A',
  'ShacklesOfLoneliness_B6C': 'B6C',
  'ShacklesOfTime_AB5': 'AB5',
  'ShacklesOfTime_B3A': 'B3A',
  'ShacklesOfTime_B3B': 'B3B',
  'ShadeShift_1E8': '1E8',
  'ShadeShift_7DB': '7DB',
  'Shadewalker': '314',
  'ShadowFang_1FC': '1FC',
  'ShadowFang_521': '521',
  'ShadowFlare': 'BE',
  'ShadowLimb': '47C',
  'ShadowLinks_47B': '47B',
  'ShadowLinks_6FE': '6FE',
  'ShadowOfDeath': '11A6',
  'ShadowOfTheDragon_8AB': '8AB',
  'ShadowOfTheDragon_A57': 'A57',
  'ShadowWalker': 'F08',
  'ShadowWall': '2EB',
  'ShadowbiteReady': 'BBA',
  'Shadowed': '977',
  'ShadowedVigil': 'EFB',
  'Shadowskin': '2E4',
  'ShakeItOffOverTime': '83C',
  'ShakeItOff_5B1': '5B1',
  'ShakeItOff_7C9': '7C9',
  'SharedGrotesquerie_128E': '128E',
  'SharedGrotesquerie_129A': '129A',
  'SharedSentence': '462',
  'SharkEye': '48F',
  'SharkEyeIi': '490',
  'Sharpcast': '363',
  'SharpenedKnife': 'D3',
  'SharpenedSights': 'ED9',
  'SheerWill': '6C1',
  'ShellL': '66B',
  'Sheltron_2D8': '2D8',
  'Sheltron_740': '740',
  'ShieldBearer': '98E',
  'ShieldOath_573': '573',
  'ShieldOath_C74': 'C74',
  'ShieldOfTheFury': 'B0F',
  'ShieldOfTheHeavens': '3B1',
  'ShieldProtocolA': '8F0',
  'ShieldProtocolB': '8F1',
  'ShieldProtocolC': '8F2',
  'ShieldSamba': '722',
  'ShieldSmite': '10BB',
  'ShieldWall': 'C2',
  'Shieldbearer': '6C5',
  'ShiningEncouragement_1150': '1150',
  'ShiningEncouragement_FC1': 'FC1',
  'ShiningMoonstone': '570',
  'Shirahadori': '1095',
  'ShockSpikes_8D7': '8D7',
  'ShockSpikes_966': '966',
  'ShockSpikes_C7': 'C7',
  'Shocked': '5DA',
  'ShockingConception': 'D0B',
  'ShockingCounter': '3B4',
  'ShockingCross': 'F89',
  'ShortFuse': '115E',
  'ShroudOfSaints': '9A',
  'SiblingRevelry': 'D3D',
  'SilenceResistance_28': '28',
  'SilenceResistance_549': '549',
  'Silence_1176': '1176',
  'Silence_424': '424',
  'Silence_543': '543',
  'Silence_7': '7',
  'Silenced': '27A',
  'Silhouette': '313',
  'SilkenFlow': 'A86',
  'SilkenSymmetry': 'A85',
  'SilverSickness': '10A8',
  'SilveredFate': 'CE0',
  'SinBearer': '11D7',
  'SingleMind': '2F8',
  'Sinking': '4F9',
  'SirenSong': '172',
  'SixFulmsUnder': '237',
  'SixSidedStar_9D2': '9D2',
  'SixSidedStar_C60': 'C60',
  'Skewer': '185',
  'SkillSpeedUp': '125',
  'SkyHigh': 'C6C',
  'SkyShatter': 'C6D',
  'Skyblind': 'A65',
  'Skyborne': '69A',
  'SkysTheLimit': '12E0',
  'SlashingResistanceDownIi': '4F8',
  'SlashingResistanceDown_23C': '23C',
  'SlashingResistanceDown_333': '333',
  'SlashingResistanceDown_69D': '69D',
  'SlashingResistanceDown_9CC': '9CC',
  'SlashingResistanceDown_C3A': 'C3A',
  'SlashingResistanceUp': '2D0',
  'SleepResistance_54A': '54A',
  'SleepResistance_7AF': '7AF',
  'Sleep_3': '3',
  'Sleep_39E': '39E',
  'Sleep_544': '544',
  'Sleep_553': '553',
  'Sleep_5E6': '5E6',
  'Sleep_63C': '63C',
  'Sleep_79B': '79B',
  'Sleep_BA7': 'BA7',
  'Sleep_D8A': 'D8A',
  'SleepingDark': '692',
  'SleepingLight': '693',
  'SleeveDraw': '786',
  'Slime_239': '239',
  'Slime_329': '329',
  'SlipperyGround': 'E6D',
  'SlipperyPrey_1DB': '1DB',
  'SlipperyPrey_299': '299',
  'SlipperySlope': 'E77',
  'Slipping': 'C9B',
  'Slipstream_A92': 'A92',
  'Slipstream_C99': 'C99',
  'Slipstream_C9A': 'C9A',
  'Slither': 'FFF',
  'SlowResistance': '548',
  'Slow_1AB': '1AB',
  'Slow_1BA': '1BA',
  'Slow_231': '231',
  'Slow_542': '542',
  'Slow_5E5': '5E5',
  'Slow_620': '620',
  'Slow_8C6': '8C6',
  'Slow_9': '9',
  'Slow_A': 'A',
  'Slow_C1': 'C1',
  'Slow_D88': 'D88',
  'Slow_DA5': 'DA5',
  'Sludge_10E': '10E',
  'Sludge_11F': '11F',
  'Sludge_216': '216',
  'Sludge_56A': '56A',
  'Sludge_825': '825',
  'Sludge_B67': 'B67',
  'Sludge_B84': 'B84',
  'Sludge_BFF': 'BFF',
  'Sludge_C00': 'C00',
  'Smackdown': '814',
  'SmileyFace': 'ACB',
  'SmokeScreen': '315',
  'SmotheringWaters': '73D',
  'Smudge_1011': '1011',
  'Smudge_E64': 'E64',
  'Snagging': '2F9',
  'SnakesBane': '1002',
  'Sneak': '2F',
  'SniperCannonFodder': 'D61',
  'SnowFort': '1365',
  'Snowball': '25F',
  'Snowman': '166',
  'SoakingWet': '78F',
  'Soaring': '5B9',
  'SoleSurvivor': '51A',
  'SolemnVow': 'B4F',
  'SolidShield': '66F',
  'SoloStep': '10D9',
  'Solosplice': 'D11',
  'SomanouticBarrier': 'B1C',
  'SonicBreak': '72D',
  'Soteria': 'A32',
  'SoulOfDevotion': 'ABD',
  'SoulOfFire_6D7': '6D7',
  'SoulOfFire_6F7': '6F7',
  'SoulOfFire_D52': 'D52',
  'SoulOfFriendship': 'ABC',
  'SoulOfIce_6D8': '6D8',
  'SoulOfIce_6F8': '6F8',
  'SoulOfIce_D53': 'D53',
  'SoulOfTheBeast': 'DD8',
  'SoulOfTheMage': 'DD6',
  'SoulOfTheMartialist': 'DD7',
  'SoulReaver_A1B': 'A1B',
  'SoulReaver_B26': 'B26',
  'SoulResonance': 'C96',
  'SoulStranded': 'D16',
  'SouldeepInvisibility': '7A4',
  'SoulsInTheBalance': 'BCC',
  'Soulsow_A22': 'A22',
  'Soulsow_ABE': 'ABE',
  'SparkOfDynamis': 'D78',
  'SparkOfHope': 'AE2',
  'SpdDown': '3C7',
  'SpdUp': '3C6',
  'SpearDrawn_394': '394',
  'SpearDrawn_FCC': 'FCC',
  'SpearHeld': '39B',
  'SpearfishersIntuition': 'B4B',
  'Spectator': 'E7C',
  'SpellInWaiting': '710',
  'SpellInWaitingDarkAeroIii': '99F',
  'SpellInWaitingDarkBlizzardIii': '99E',
  'SpellInWaitingDarkEruption': '99C',
  'SpellInWaitingDarkFireIii_712': '712',
  'SpellInWaitingDarkFireIii_997': '997',
  'SpellInWaitingDarkWaterIii': '99D',
  'SpellInWaitingFlare_690': '690',
  'SpellInWaitingFlare_83A': '83A',
  'SpellInWaitingHellWind': '713',
  'SpellInWaitingQuietus_104E': '104E',
  'SpellInWaitingQuietus_9E3': '9E3',
  'SpellInWaitingRefrain': '1115',
  'SpellInWaitingReturnIi': '104B',
  'SpellInWaitingReturnIv': '68F',
  'SpellInWaitingReturn_1070': '1070',
  'SpellInWaitingReturn_9A0': '9A0',
  'SpellInWaitingShadoweye_714': '714',
  'SpellInWaitingShadoweye_998': '998',
  'SpellInWaitingUnholyDarkness_711': '711',
  'SpellInWaitingUnholyDarkness_996': '996',
  'SpellShield': '670',
  'SpellSpeedUp': '126',
  'SpickAndSpan': 'E35',
  'SpicyCirculationI': 'E1D',
  'SpicyCirculationXxii': 'E1C',
  'SpineshatterDiveTarget': 'AC4',
  'SpinningConductor': 'FA4',
  'Spinning_B9D': 'B9D',
  'Spinning_E76': 'E76',
  'SpireDrawn_396': '396',
  'SpireDrawn_C1F': 'C1F',
  'SpireDrawn_FCE': 'FCE',
  'SpireHeld': '39D',
  'SpiritDartL': '676',
  'SpiritOfTheAetherweaver': '907',
  'SpiritOfTheBeast': '914',
  'SpiritOfTheBloodsucker': '913',
  'SpiritOfTheBreathtaker': '912',
  'SpiritOfTheDivine': '987',
  'SpiritOfTheDuelist': '984',
  'SpiritOfTheElder': '983',
  'SpiritOfTheFiendhunter': '985',
  'SpiritOfTheGambler': '982',
  'SpiritOfTheGuardian': '90C',
  'SpiritOfTheIndomitable': '986',
  'SpiritOfTheIrregular': '911',
  'SpiritOfTheMartialist': '908',
  'SpiritOfTheOrdained': '90D',
  'SpiritOfThePlatebearer': '90B',
  'SpiritOfTheProfane': '910',
  'SpiritOfTheRemembered': '669',
  'SpiritOfTheSavior': '909',
  'SpiritOfTheSkirmisher': '90E',
  'SpiritOfTheTemplar': '915',
  'SpiritOfTheVeteran': '90A',
  'SpiritOfTheWatcher': '90F',
  'SpitefulFlames': '1058',
  'Spjot': '160',
  'SplashingWaters_73B': '73B',
  'SplashingWaters_79D': '79D',
  'Spotlightless': '1178',
  'SpreadingFlames': 'AC6',
  'SpringTide': 'D00',
  'SprintPenalty': '447',
  'Sprint_11A8': '11A8',
  'Sprint_1E1': '1E1',
  'Sprint_32': '32',
  'Sprint_53E': '53E',
  'Sprint_60C': '60C',
  'Sprint_792': '792',
  'Spur': 'C0',
  'SquadronBattleManual': '438',
  'SquadronEngineeringManual': '43A',
  'SquadronEnlistmentManual': '43E',
  'SquadronGearMaintenanceManual': '43D',
  'SquadronSpiritbondingManual': '43B',
  'SquadronSurvivalManual': '439',
  'SquirrellyPrayer': 'E15',
  'StabWound_109': '109',
  'StabWound_45D': '45D',
  'StabWound_5BA': '5BA',
  'StabWound_820': '820',
  'StabWound_B62': 'B62',
  'StabWound_B7F': 'B7F',
  'StabWound_BF5': 'BF5',
  'StabWound_BF6': 'BF6',
  'StableSystem': 'E22',
  'Staggered': '2CB',
  'StandardFinish_71D': '71D',
  'StandardFinish_7E8': '7E8',
  'StandardFinish_839': '839',
  'StandardFinish_841': '841',
  'StandardStep_71A': '71A',
  'StandardStep_7E7': '7E7',
  'StandingFirm_120A': '120A',
  'StandingFirm_8D9': '8D9',
  'StarContributor_1139': '1139',
  'StarContributor_113F': '113F',
  'StarPrism_1017': '1017',
  'StarPrism_E63': 'E63',
  'StarcrossReady_10CE': '10CE',
  'StarcrossReady_F06': 'F06',
  'StarfallDance': 'C59',
  'StarryMuse': 'E65',
  'Starstruck_1016': '1016',
  'Starstruck_E61': 'E61',
  'StaticCharge': '23F',
  'StaticCondensation_201': '201',
  'StaticCondensation_8B5': '8B5',
  'SteadfastStance': '12C0',
  'SteadyHand': 'FD',
  'SteadyHandIi': '106',
  'SteelScales': '15D',
  'StellarSprint': '112E',
  'StellarSteadyHand': '12E7',
  'Stellation': '6D0',
  'StemTheFlow': 'A77',
  'StemTheTide_A78': 'A78',
  'StemTheTide_BD7': 'BD7',
  'Sticky_E81': 'E81',
  'Sticky_EA5': 'EA5',
  'StingingWelt': 'D9D',
  'StockHolder': '9A2',
  'StoneCurse_11B9': '11B9',
  'StoneCurse_13C2': '13C2',
  'StoneCurse_1B5': '1B5',
  'StoneCurse_589': '589',
  'StoneWall': '790',
  'Stonepack': '1126',
  'StoneskinIi': '1181',
  'StoneskinMagical': '99',
  'StoneskinPhysical': '98',
  'Stoneskin_97': '97',
  'Stoneskin_D5E': 'D5E',
  'Stormbite_4B1': '4B1',
  'Stormbite_52A': '52A',
  'StormsEye': '5A',
  'StormsPath': '198',
  'StormsSuccor': 'E26',
  'StraightShot': '82',
  'StraightShotReady': '7A',
  'StrengthDown_2D4': '2D4',
  'StrengthDown_33': '33',
  'StrengtheningStimulant': 'F76',
  'StringsOfTheMarionette': '3BF',
  'StrokeOfGenius': '48B',
  'StrongOfShield': '9EA',
  'StrongOfSpear': '9E9',
  'StrongerTogether': '9EB',
  'Stronghold': 'C3',
  'StrungUp': '151F',
  'StunResistance_27': '27',
  'StunResistance_545': '545',
  'Stun_1043': '1043',
  'Stun_1116': '1116',
  'Stun_111A': '111A',
  'Stun_1151': '1151',
  'Stun_13B3': '13B3',
  'Stun_2': '2',
  'Stun_53F': '53F',
  'Stun_5E9': '5E9',
  'Stun_5F1': '5F1',
  'Stun_5F2': '5F2',
  'Stun_8E': '8E',
  'Stun_95': '95',
  'Stun_A60': 'A60',
  'Stun_B89': 'B89',
  'Stun_C9': 'C9',
  'Stun_D50': 'D50',
  'Stun_D89': 'D89',
  'Stung': '1C1',
  'Stunstrikes': '46',
  'StygianTendrils': '952',
  'SubtleRuin': '9D0',
  'SubtractivePalette_1006': '1006',
  'SubtractivePalette_E5A': 'E5A',
  'SubtractiveSpectrum': 'E6A',
  'SubtractiveSuppressorAlpha': 'E8C',
  'SubtractiveSuppressorBeta': 'E8D',
  'SubversiveStance': '1CD',
  'Succor': 'A6',
  'SuckedIn_9B6': '9B6',
  'SuckedIn_9E1': '9E1',
  'SuffocatedWill': '254',
  'Suiton_1FB': '1FB',
  'Suiton_B17': 'B17',
  'SumOfAllSins': '11D8',
  'SummonOrder': '77B',
  'SummonOrderIi': '7AC',
  'SummonOrderIii': '7AD',
  'SummonOrderIv': '7AE',
  'SummonSeraph': 'C17',
  'SunSign': 'F38',
  'SunderingWaters': '73E',
  'Sunseal': '46F',
  'Suntouched': 'F37',
  'SuperSprint': '422',
  'Superbolide': '72C',
  'Superfluid_68C': '68C',
  'Superfluid_D7F': 'D7F',
  'SupernalGuard': 'CE7',
  'Supersplice': 'D13',
  'SupplicationReady_10B9': '10B9',
  'SupplicationReady_EF3': 'EF3',
  'Suppuration_11A0': '11A0',
  'Suppuration_177': '177',
  'Suppuration_86C': '86C',
  'Suppuration_C3D': 'C3D',
  'Surecast': 'A0',
  'SurfaceSlap': '70B',
  'SurgeProtection_205': '205',
  'SurgeProtection_8B4': '8B4',
  'SurgeVector': 'E8B',
  'SurgingTempest': 'A75',
  'SurgingWaters': '73A',
  'SurpanakhasFury': '852',
  'Suspend': '10A2',
  'Sustain': 'B8',
  'SustainedDamage_1035': '1035',
  'SustainedDamage_B77': 'B77',
  'SustainedDamage_B97': 'B97',
  'SustainedDamage_CD8': 'CD8',
  'SustainedDamage_D1F': 'D1F',
  'SustainedDamage_ED3': 'ED3',
  'SustainedDarkDamage': 'B54',
  'SustainedLightDamage': 'B55',
  'Swarmed': '1C0',
  'SweepingWaters': '73F',
  'Sweltering': '1161',
  'Swift': '117D',
  'SwiftDeception': 'B8D',
  'SwiftL': '66C',
  'SwiftSprint_1121': '1121',
  'SwiftSprint_1265': '1265',
  'SwiftSprint_BB4': 'BB4',
  'SwiftSprint_BB5': 'BB5',
  'SwiftSprint_C35': 'C35',
  'Swiftcast_52D': '52D',
  'Swiftcast_7C3': '7C3',
  'Swiftcast_A7': 'A7',
  'SwiftkicksGoblixer': '3E7',
  'Swiftscaled_1019': '1019',
  'Swiftscaled_E55': 'E55',
  'SwiftskinsVenom': 'E4A',
  'Swiftsong_85': '85',
  'Swiftsong_86': '86',
  'SwirlingWaters': '73C',
  'SwordBearer': '98D',
  'SwordOath_17D': '17D',
  'SwordOath_4E': '4E',
  'SwordOath_7C7': '7C7',
  'SwordOfTheHeavens': '3B0',
  'Swordbearer': '6C6',
  'Synastry_34D': '34D',
  'Synastry_34E': '34E',
  'Synastry_538': '538',
  'Synastry_539': '539',
  'SynchronizationCodeSmell': 'D6C',
  'SynchronizationDebugger_683': '683',
  'SynchronizationDebugger_D66': 'D66',
  'SynchronizedFiresnaking': '12D9',
  'SynchronizedWatersnaking': '12DA',
  'SystemError': 'DEA',
  'SystemLock': 'A12',
  'SystemShock': '8B8',
  'Tactician_4AD': '4AD',
  'Tactician_79F': '79F',
  'Tactician_881': '881',
  'Tailwind_2A6': '2A6',
  'Tailwind_643': '643',
  'Tangled': 'CD4',
  'TargetLeft': '55F',
  'TargetRight': '55E',
  'Targeting': 'D14',
  'TartarusMode': '61B',
  'Taurochole': 'A3B',
  'TechnicalFinish_71E': '71E',
  'TechnicalFinish_802': '802',
  'TechnicalStep_71B': '71B',
  'TechnicalStep_801': '801',
  'TemperaCoat_1012': '1012',
  'TemperaCoat_E66': 'E66',
  'TemperaGrassa_1013': '1013',
  'TemperaGrassa_E67': 'E67',
  'Temperance_750': '750',
  'Temperance_751': '751',
  'Temperance_7F5': '7F5',
  'Temperance_7F6': '7F6',
  'Temperance_F90': 'F90',
  'Temperance_F91': 'F91',
  'TemperedWill_2C8': '2C8',
  'TemperedWill_4B': '4B',
  'TemporalBarrier': '623',
  'TemporalDisplacement_384': '384',
  'TemporalDisplacement_45F': '45F',
  'TemporalDisplacement_875': '875',
  'TemporaryInsanity': '2C7',
  'TemporaryMisdirection_58E': '58E',
  'TemporaryMisdirection_B78': 'B78',
  'TemporaryMisdirection_E6E': 'E6E',
  'TemporaryMisdirection_F45': 'F45',
  'TemptedToTango': '12BB',
  'TenChiJin': '4A2',
  'TenderAnaphylaxis': '8FD',
  'Tendo': 'F10',
  'TendoSetsugekkaReady': 'C83',
  'TenebrousGrasp': 'B10',
  'Tengentsu': 'F0D',
  'TengentsusForesight': 'F0E',
  'TenriJindoReady': 'F0B',
  'TerminalVelocity': '581',
  'TerrestrialChains': '1129',
  'Terror_42': '42',
  'Terror_578': '578',
  'Terror_F66': 'F66',
  'Testudo': '883',
  'TetradmoniacBonds': 'E70',
  'ThaliaksWard': 'E7',
  'ThatWhichBindsUs': '169',
  'TheArrow_33F': '33F',
  'TheArrow_75C': '75C',
  'TheArrow_D4A': 'D4A',
  'TheArrow_F30': 'F30',
  'TheBalance_33D': '33D',
  'TheBalance_53A': '53A',
  'TheBalance_75A': '75A',
  'TheBalance_F2F': 'F2F',
  'TheBole_33E': '33E',
  'TheBole_53B': '53B',
  'TheBole_75B': '75B',
  'TheBole_F32': 'F32',
  'TheDeceiver': '5A5',
  'TheDragonsCurse': '131',
  'TheEcho_2A': '2A',
  'TheEcho_EF': 'EF',
  'TheEwer_341': '341',
  'TheEwer_53C': '53C',
  'TheEwer_75E': '75E',
  'TheEwer_F33': 'F33',
  'TheGentlemanFantastick': 'D5F',
  'TheGivingLand': '70A',
  'TheHeatOfBattle': '16D',
  'TheNarwhalsLullaby_FE1': 'FE1',
  'TheNarwhalsLullaby_FE2': 'FE2',
  'TheOneDragon': '611',
  'TheScroll': 'A0C',
  'TheSpear_340': '340',
  'TheSpear_75D': '75D',
  'TheSpear_F31': 'F31',
  'TheSpire_342': '342',
  'TheSpire_53D': '53D',
  'TheSpire_75F': '75F',
  'TheSpire_F34': 'F34',
  'TheTwelvesBounty': '339',
  'TheUnforgotten': 'C88',
  'TheUpholder': '5A6',
  'TheWanderersMinuet_361': '361',
  'TheWanderersMinuet_8A7': '8A7',
  'TheWanderersMinuet_8A8': '8A8',
  'TheWardensPaean_362': '362',
  'TheWardensPaean_C47': 'C47',
  'TheWeightOfLight': '103F',
  'TheWormsCurse': '58B',
  'ThermalHigh_17C': '17C',
  'ThermalHigh_5F6': '5F6',
  'ThermalLow_17B': '17B',
  'ThermalLow_5F5': '5F5',
  'ThinAir': '4C1',
  'ThinIce_25C': '25C',
  'ThinIce_389': '389',
  'ThinIce_38F': '38F',
  'ThinIce_62B': '62B',
  'ThinIce_62C': '62C',
  'ThirdBrand': 'CC6',
  'ThirdChakra': '31B',
  'ThirdEye': '4D0',
  'ThirdFlame': 'CCA',
  'ThirdInLine': 'BBE',
  'ThornedFlourish_10E1': '10E1',
  'ThornedFlourish_F24': 'F24',
  'Thornpricked': 'AF4',
  'ThornsOfDeathI_1172': '1172',
  'ThornsOfDeathI_1193': '1193',
  'ThornsOfDeathIi_1173': '1173',
  'ThornsOfDeathIi_1194': '1194',
  'ThornsOfDeathIii_1174': '1174',
  'ThornsOfDeathIii_1195': '1195',
  'ThornsOfDeathIv_1175': '1175',
  'ThornsOfDeathIv_1196': '1196',
  'ThornyVine': '1BD',
  'Threatened': '614',
  'ThreeMudra': '525',
  'ThreefoldFanDance': '71C',
  'Threshold_A23': 'A23',
  'Threshold_B2C': 'B2C',
  'ThriceComeRuin_9E2': '9E2',
  'ThriceComeRuin_9E5': '9E5',
  'ThriceComeRuin_D96': 'D96',
  'ThrillOfBattle_57': '57',
  'ThrillOfBattle_C71': 'C71',
  'ThrillOfWar': '5B0',
  'Throttle_2BC': '2BC',
  'Throttle_3AA': '3AA',
  'ThrownForALoop': '192',
  'ThunderAlchemy': 'AC1',
  'ThunderCharged': '5CD',
  'ThunderIi_81B': '81B',
  'ThunderIi_A2': 'A2',
  'ThunderIii': 'A3',
  'ThunderIv': '4BA',
  'ThunderOfTheRroneek': 'F69',
  'Thunder_52C': '52C',
  'Thunder_A1': 'A1',
  'Thunderclap_203': '203',
  'Thunderclap_C65': 'C65',
  'Thundercloud_555': '555',
  'Thundercloud_A4': 'A4',
  'Thunderhead': 'F1E',
  'ThunderousEcho': 'CDD',
  'ThunderousMemory': '111E',
  'Thunderstruck_1D2': '1D2',
  'Thunderstruck_B11': 'B11',
  'TidalspoutTarget': '1276',
  'TimeAndTide': 'E9B',
  'TimesFive_ECE': 'ECE',
  'TimesFive_F63': 'F63',
  'TimesThree_E89': 'E89',
  'TimesThree_F62': 'F62',
  'TimesUp': '5B8',
  'Tingling': '9BC',
  'Tireless': '277',
  'TitansFavor': 'B25',
  'TizonasBastion_B5B': 'B5B',
  'TizonasBastion_B5C': 'B5C',
  'ToTheDungeons': 'B05',
  'ToadOil': '6C9',
  'Toad_1B7': '1B7',
  'Toad_1B9': '1B9',
  'Toad_44D': '44D',
  'Toad_A6F': 'A6F',
  'TopOfTheHive': '102F',
  'TorcleaverReady': '10C1',
  'TornadoEdict': '696',
  'TorrentialRuin': '9CE',
  'TouchOfDeath': '6A',
  'TouchOfFrost': '9BE',
  'TowerDefense_597': '597',
  'TowerDefense_598': '598',
  'ToxicAlchemy': 'AC2',
  'ToxicConception': 'D0D',
  'ToxicMinerals': '115C',
  'Toxicosis_111B': '111B',
  'Toxicosis_122C': '122C',
  'Toxicosis_AAF': 'AAF',
  'Toxicosis_BB8': 'BB8',
  'Toxicosis_C09': 'C09',
  'Toxicosis_C0A': 'C0A',
  'Toxicosis_D4F': 'D4F',
  'Toxicosis_F8D': 'F8D',
  'Toxicosis_F8E': 'F8E',
  'Toxikon': 'C29',
  'TpBleed': '14',
  'TrainedPerfection': 'EE5',
  'Transcendent_1A2': '1A2',
  'Transcendent_A58': 'A58',
  'Transfiguration_1264': '1264',
  'Transfiguration_235': '235',
  'Transfiguration_2C1': '2C1',
  'Transfiguration_58F': '58F',
  'Transfiguration_599': '599',
  'Transfiguration_5A8': '5A8',
  'Transfiguration_5B3': '5B3',
  'Transfiguration_648': '648',
  'Transfiguration_649': '649',
  'Transfiguration_9F4': '9F4',
  'Transfiguration_AA7': 'AA7',
  'Transparent': '1A0',
  'TransparentIi': '4F2',
  'Transporting_1118': '1118',
  'Transporting_194': '194',
  'Trapper': '3DB',
  'Trauma': 'ED4',
  'Triangulate': 'D9',
  'TrickAttack_7DE': '7DE',
  'TrickAttack_CB6': 'CB6',
  'TrickleOfFire': 'B71',
  'Triple': '296',
  'Triplecast': '4BB',
  'TritonicGravity': '1156',
  'Troubadour': '78E',
  'TroubadoursBallad': '4A3',
  'TroubadoursMinuet_4A6': '4A6',
  'TroubadoursMinuet_5A9': '5A9',
  'TroubadoursPaeon_4A5': '4A5',
  'TroubadoursPaeon_5AA': '5AA',
  'TrueBenison': 'AE7',
  'TrueBravery': 'AE5',
  'TrueFinish': 'B88',
  'TrueHallowedGround_8EF': '8EF',
  'TrueHallowedGround_AEA': 'AEA',
  'TrueMedicaIi': 'AE8',
  'TrueNorth': '4E2',
  'TrueRampart': 'AED',
  'TrueReprisal': 'AEE',
  'TrueSentinel': 'AEC',
  'TrueSight': 'D4',
  'TrueStep': 'AE6',
  'TrueStoneskin': 'AE9',
  'TrueVirtue': '6EB',
  'TrueWalkingDead': '8FF',
  'TrulyBerserk': '906',
  'TrustyShield': '787',
  'TruthOfForests': 'DD',
  'TruthOfMountains': 'DE',
  'TruthOfOceans': '495',
  'TsubameGaeshiReady': 'F0C',
  'TsubameGaeshi_1078': '1078',
  'TsubameGaeshi_1079': '1079',
  'TsubameGaeshi_107A': '107A',
  'TuraliWill': 'F6A',
  'TuralsEmbrace': 'F73',
  'Turbulence': '2CC',
  'TurretReset': '4E3',
  'TwiceComeRuin_9B3': '9B3',
  'TwiceComeRuin_9B5': '9B5',
  'TwiceComeRuin_9E6': '9E6',
  'TwinFates': '6D6',
  'TwinSnakes': '65',
  'TwistOfFate_508': '508',
  'TwistOfFate_509': '509',
  'TwistedTongue': 'FE0',
  'TwistingViper': 'B92',
  'TwoSwipeMemory': 'FD5',
  'UltrosSimulation': '5D1',
  'UmbralAttenuation': '84A',
  'UmbralCloak': '6B1',
  'UmbralEffect': '8BF',
  'UmbralEssence': '6AF',
  'UmbralFreeze': 'C91',
  'UmbralIceIi_B1': 'B1',
  'UmbralIceIi_C8F': 'C8F',
  'UmbralIceIii_B2': 'B2',
  'UmbralIceIii_D36': 'D36',
  'UmbralIce_B0': 'B0',
  'UmbralIce_C8E': 'C8E',
  'UmbralRays': 'B5D',
  'UmbralTilt': 'DF8',
  'UmbralbrightSoul': 'DFB',
  'UmbralstrongSoul': 'DFD',
  'Unbecoming': '1312',
  'UnbreakableFlesh_1291': '1291',
  'UnbreakableFlesh_1293': '1293',
  'Unbridled': '30E',
  'UnbrokenMettle': 'FC2',
  'Unchained': '5C',
  'Uncontrollable': '2DE',
  'UndeadRebirth': 'CB7',
  'UndeadRedemption': 'BDF',
  'UnderflowCodeSmell': 'D6E',
  'UnderflowDebugger_685': '685',
  'UnderflowDebugger_D68': 'D68',
  'UndyingFlame': 'A91',
  'Unfooled': '182',
  'Unforgotten': 'B58',
  'Unguarded': 'BCD',
  'Uninterrupted': '1140',
  'Unlimited': 'ADD',
  'Unmagicked': '60D',
  'Unnerved': '592',
  'UnrelentingAnguish': '5C8',
  'UnrelentingCounter': '3BA',
  'Unsealed': '10F3',
  'UnsealedSeitonTenchu': 'C78',
  'UnshakableLoyalty': 'BC0',
  'Unstable': '8C9',
  'UnstableFactor': 'E09',
  'UnstableGravity_550': '550',
  'UnstableGravity_834': '834',
  'Unveiled': '654',
  'UnwaveringWill': '89F',
  'UnwillingHost': '3A9',
  'UtmostCaution': '2F6',
  'ValuedCustomer': '1120',
  'Vanished': '5D8',
  'VariantCureSet': 'DED',
  'VariantEagleEyeShotSet': '131C',
  'VariantRaiseSet': 'DEF',
  'VariantRampartSet': 'DF1',
  'VariantSpiritDartSet': 'DF0',
  'VariantUltimatumSet': 'DEE',
  'VauntedHero': '1064',
  'VauntedVillain': '1065',
  'VauthrysBlessing_779': '779',
  'VauthrysBlessing_782': '782',
  'VauthrysBlessing_783': '783',
  'VauthrysBlessing_784': '784',
  'VauthrysBlessing_785': '785',
  'VegetalVapours': 'D8B',
  'VeilOfDarkness': '1053',
  'VeilOfGukumatz': '771',
  'VeilOfLight': '605',
  'VeilOfShadow': '604',
  'VeilOfTheWhorl_1DE': '1DE',
  'VeilOfTheWhorl_6BC': '6BC',
  'Veneration': '8B2',
  'Vengeance': '59',
  'VengefulFlame': 'E1A',
  'VengefulPyre': 'E1B',
  'VenomousBite': '7C',
  'VerfireReady': '4D2',
  'VermedicaIi': 'F75',
  'VermilionRadiance': 'CA1',
  'VerstoneReady': '4D3',
  'Vertigo': '1FA',
  'VeteranTrade': '491',
  'Vigilance': '10B5',
  'Vigilant': 'F3E',
  'Virus_5D5': '5D5',
  'Virus_B6': 'B6',
  'ViscousAetheroplasm_171': '171',
  'ViscousAetheroplasm_5FC': '5FC',
  'VitalSight': 'ADF',
  'VitalSign': '744',
  'VitalityDown': '34',
  'Vitalized_EDE': 'EDE',
  'Vitalized_EDF': 'EDF',
  'VoiceOfFortitude_115': '115',
  'VoiceOfFortitude_134': '134',
  'VoiceOfValor_114': '114',
  'VoiceOfValor_133': '133',
  'Voidblood': '310',
  'Voidbound': '1D4',
  'VortexBarrier': 'BC4',
  'Vril': '50A',
  'VulnerabilityDown_1154': '1154',
  'VulnerabilityDown_135B': '135B',
  'VulnerabilityDown_155B': '155B',
  'VulnerabilityDown_15E': '15E',
  'VulnerabilityDown_196': '196',
  'VulnerabilityDown_324': '324',
  'VulnerabilityDown_390': '390',
  'VulnerabilityDown_3A1': '3A1',
  'VulnerabilityDown_3F': '3F',
  'VulnerabilityDown_44C': '44C',
  'VulnerabilityDown_4CA': '4CA',
  'VulnerabilityDown_609': '609',
  'VulnerabilityDown_6DF': '6DF',
  'VulnerabilityDown_6F6': '6F6',
  'VulnerabilityDown_896': '896',
  'VulnerabilityDown_95B': '95B',
  'VulnerabilityDown_9CA': '9CA',
  'VulnerabilityDown_D20': 'D20',
  'VulnerabilityDown_DA3': 'DA3',
  'VulnerabilityDown_EAD': 'EAD',
  'VulnerabilityUp_1117': '1117',
  'VulnerabilityUp_1BC': '1BC',
  'VulnerabilityUp_233': '233',
  'VulnerabilityUp_27E': '27E',
  'VulnerabilityUp_2CA': '2CA',
  'VulnerabilityUp_326': '326',
  'VulnerabilityUp_37D': '37D',
  'VulnerabilityUp_40': '40',
  'VulnerabilityUp_41E': '41E',
  'VulnerabilityUp_4B8': '4B8',
  'VulnerabilityUp_57A': '57A',
  'VulnerabilityUp_584': '584',
  'VulnerabilityUp_63D': '63D',
  'VulnerabilityUp_6FD': '6FD',
  'VulnerabilityUp_735': '735',
  'VulnerabilityUp_8A5': '8A5',
  'VulnerabilityUp_92B': '92B',
  'VulnerabilityUp_B60': 'B60',
  'VulnerabilityUp_CA': 'CA',
  'VulnerabilityUp_D21': 'D21',
  'VulnerabilityUp_D26': 'D26',
  'VulnerabilityUp_DE5': 'DE5',
  'WalkingDead': '32B',
  'WanderersFate': '97E',
  'WanderersMinuet': '7D9',
  'WanderingEyes': 'FAA',
  'WaningNocturne': '6BF',
  'WardensGrace': '882',
  'WardingScale_CD1': 'CD1',
  'WardingScale_CE6': 'CE6',
  'WarmTint': '1163',
  'Warmonger_940': '940',
  'Warmonger_94C': '94C',
  'WasteNot': 'FC',
  'WasteNotIi': '101',
  'WaterResistanceDown': '1AF',
  'WaterResistanceDownIi_401': '401',
  'WaterResistanceDownIi_485': '485',
  'WaterResistanceDownIi_82E': '82E',
  'WaterResistanceDownIi_860': '860',
  'WaterResistanceUp': '209',
  'Watersnaking': '136F',
  'WateryGrave_12DD': '12DD',
  'WateryGrave_1E6': '1E6',
  'WateryGrave_6E8': '6E8',
  'Wavelength_116E': '116E',
  'Wavelength_116F': '116F',
  'WaxenFlesh': '15A',
  'WaxingNocturne': '6B6',
  'Waymark': '8C7',
  'WeakMagitekField': '6E7',
  'Weakness': '2B',
  'WeaponPilfered': '10B7',
  'WellDoneSteak': '11DD',
  'WellFed': '30',
  'WestWindOfChange': '105E',
  'WesterlyWinds': '1517',
  'WetPlate': '264',
  'Whaleback': '2CF',
  'WhatYouSee': '163',
  'WheelInMotion': '323',
  'WheelOfFortune_3BC': '3BC',
  'WheelOfFortune_4B6': '4B6',
  'WhisperedIncantation': 'B1E',
  'WhisperingDawn': '13B',
  'WhispersManifest': 'B1F',
  'Whistle': '370',
  'WhiteShift': 'CAD',
  'WhiteWound': '564',
  'WhoIsShe_A5E': 'A5E',
  'WhoIsShe_A5F': 'A5F',
  'WickedWater': '10EE',
  'WickedWhim': 'B06',
  'WideAwake': '7FF',
  'WideEyed': 'FE3',
  'Wildfire_35D': '35D',
  'Wildfire_52B': '52B',
  'Wildfire_79A': '79A',
  'Wildfire_7E2': '7E2',
  'WillOfTheWater': '2CE',
  'WillOfTheWind': '2CD',
  'WillToLive': 'B8B',
  'Willful': 'B8A',
  'WillingToWaltz': '12BD',
  'WindAspected': 'B04',
  'WindResistanceDownIi_41C': '41C',
  'WindResistanceDownIi_830': '830',
  'WindResistanceDown_2AD': '2AD',
  'WindResistanceDown_37E': '37E',
  'WindResistanceUp': '20A',
  'WindResonance': '7D7',
  'Windbite': '81',
  'WindborneEnd': '1128',
  'Windburn_10D': '10D',
  'Windburn_11E': '11E',
  'Windburn_214': '214',
  'Windburn_5E4': '5E4',
  'Windburn_6BB': '6BB',
  'Windburn_824': '824',
  'Windburn_B66': 'B66',
  'Windburn_B83': 'B83',
  'Windburn_BFD': 'BFD',
  'Windburn_BFE': 'BFE',
  'Windburn_E79': 'E79',
  'Windburn_E7A': 'E7A',
  'Windburn_EB': 'EB',
  'Windpack': '1125',
  'WindsRumination': 'F02',
  'Windwall': '2A7',
  'WingMotif': '100A',
  'WingSketch': '101D',
  'WingedConception': 'D09',
  'WingedMuse': '100E',
  'WingedRedemption': 'E39',
  'WingedReprobation': 'E38',
  'WingedShield': '76C',
  'Wingmark': '1162',
  'WingsOfTheRaptor': '3B3',
  'WisdomOfTheAetherweaver': '65F',
  'WisdomOfTheBreathtaker': '668',
  'WisdomOfTheDuelist': '6CC',
  'WisdomOfTheElder': '6CB',
  'WisdomOfTheFiendhunter': '6CD',
  'WisdomOfTheGuardian': '662',
  'WisdomOfTheIndomitable': '6CE',
  'WisdomOfTheIrregular': '667',
  'WisdomOfTheMartialist': '660',
  'WisdomOfTheOrdained': '663',
  'WisdomOfThePlatebearer': '661',
  'WisdomOfTheSkirmisher': '664',
  'WisdomOfTheTemplar': '666',
  'WisdomOfTheWatcher': '665',
  'Withering': '531',
  'WithoutSin': '11D9',
  'Woken_5F9': '5F9',
  'Woken_637': '637',
  'WolfsHeartKit': '47D',
  'Wounded': '4E8',
  'Wrath': '5D',
  'WrathIi': '5E',
  'WrathIii': '5F',
  'WrathIv': '60',
  'WrathfulRevelation': 'DF2',
  'Wrathful_10BE': '10BE',
  'Wrathful_F3D': 'F3D',
  'WreathOfFire': '10DB',
  'WreathOfIce': '10DC',
  'Wyrmclaw_8D2': '8D2',
  'Wyrmclaw_CBF': 'CBF',
  'Wyrmfang_8D3': '8D3',
  'Wyrmfang_CC0': 'CC0',
  'XMarkedSoul': 'E00',
  'XMarksTheShock': 'F8A',
  'XtremeFiresnaking': '12DB',
  'XtremeWatersnaking': '12DC',
  'YellowPaint': '5BB',
  'YourMove2Squares': '9B0',
  'YourMove3Squares': '9B1',
  'YourMove4Squares': '9B2',
  'Yukikaze': '4CB',
  'ZanshinReady_526': '526',
  'ZanshinReady_F0F': 'F0F',
  'ZeshoMeppoReady': '10D1',
  'Zoe': 'A33',
  'Zombification_173': '173',
  'Zombification_901': '901',
  '[1]': 'F96',
  '[2]': 'F97',
  '[3]': 'F98',
  '[4]': 'F99',
  '[5]': 'F9A',
  '[6]': 'F9B',
  '[]_7BC': '7BC',
  '[]_7FE': '7FE',
  '[]_C2D': 'C2D',
  'ii': 'C2A',
} as const;

export default data;
